export const ConstantsLagoon = {
  CONTENT_FILTERS: {
    INFO_MODAL_CONTENT: 'RESULT_SORT_INFO_MODAL_CONTENT',
    PREMIUM_CARE_PHYSICIAN_CONTENT: 'PREMIUM_CARE_PHYSICIAN_CONTENT',
    PREMIUM_CARE_POPOVER_URL: 'PREMIUM_CARE_POPOVER_URL',
    PREFERRED_FACILITY_CONTENT: 'PREFERRED_FACILITY_CONTENT',
    BEST_MATCH_MEDICAL_PROVIDER: 'BEST_MATCH_MEDICAL_PROVIDER',
    BEST_MATCH_MEDICAL_PROVIDER_GROUP: 'BEST_MATCH_MEDICAL_PROVIDER_GROUP',
    BEST_MATCH_MEDICAL_FACILITY: 'BEST_MATCH_MEDICAL_FACILITY',
    BEST_MATCH_BH_PROVIDER: 'BEST_MATCH_BH_PROVIDER',
    BEST_MATCH_BH_PROVIDER_GROUP: 'BEST_MATCH_BH_PROVIDER_GROUP',
    BEST_MATCH_BH_FACILITY: 'BEST_MATCH_BH_FACILITY',
    BEST_MATCH_DENTAL_PROVIDER: 'BEST_MATCH_DENTAL_PROVIDER',
    BEST_MATCH_POPOVER_CONTENT_VISION_PROVIDER:
      'BEST_MATCH_POPOVER_CONTENT_VISION_PROVIDER',
    BEST_MATCH_POPOVER_CONTENT_VISION_FACILITY:
      'BEST_MATCH_POPOVER_CONTENT_VISION_FACILITY',
    BEST_MATCH_POPOVER_CONTENT: 'BEST_MATCH_POPOVER_CONTENT',
    COST_TAB_IN_NETWORK_TEXT: 'COST_TAB_IN_NETWORK_TEXT',
    COST_TAB_COST_ESTIMATES_TEXT: 'COST_TAB_COST_ESTIMATES_TEXT',
    COST_TAB_COST_ESTIMATES_HEADING: 'COST_TAB_COST_ESTIMATES_HEADING',
    COST_TAB_COST_ESTIMATES_NOTIFICATION:
      'COST_TAB_COST_ESTIMATES_NOTIFICATION',
    COST_TAB_COST_ESTIMATES_NOT_AVAILABLE_HEADING:
      'COST_TAB_COST_ESTIMATES_NOT_AVAILABLE_HEADING',
    COST_TAB_COST_ESTIMATES_NOT_AVAILABLE_TEXT:
      'COST_TAB_COST_ESTIMATES_NOT_AVAILABLE_TEXT',
    COST_TAB_IN_NETWORK_HEADING: 'COST_TAB_IN_NETWORK_HEADING',
    CARE_TYPE_TITLE: 'CARE_TYPE_TITLE',
    OON_MESSAGE: 'OON_MESSAGE',
    SELECT_CARE_TYPE_TITLE: 'SELECT_CARE_TYPE_TITLE',
    PHYSICIAN_DIRECTORY_DIRECTORY_CONTENT:
      'PHYSICIAN_DIRECTORY_DIRECTORY_CONTENT',
    PHYSICIAN_DIRECTORY_LOCATION_CONTENT:
      'PHYSICIAN_DIRECTORY_LOCATION_CONTENT',
    PHYSICIAN_DIRECTORY_SEARCH_INPUT_LABEL:
      'PHYSICIAN_DIRECTORY_SEARCH_INPUT_LABEL',
    PHYSICIAN_DIRECTORY_SEARCH_ERROR: 'PHYSICIAN_DIRECTORY_SEARCH_ERROR',
    PHYSICIAN_DIRECTORY_SEARCH_INPUT_BY_NAME_LABEL:
      'PHYSICIAN_DIRECTORY_SEARCH_INPUT_BY_NAME_LABEL',
    PHYSICIAN_DIRECTORY_SEARCH_INPUT_BY_SPECIALITY_LABEL:
      'PHYSICIAN_DIRECTORY_SEARCH_INPUT_BY_SPECIALITY_LABEL',
    PHYSICIAN_DIRECTORY_SEARCH_INPUT_OPTIONS:
      'PHYSICIAN_DIRECTORY_SEARCH_INPUT_OPTIONS',
    PHYSICIAN_DIRECTORY_HOSPITAL_COPY_CONTENT:
      'PHYSICIAN_DIRECTORY_HOSPITAL_COPY_CONTENT',
    PHYSICIAN_DIRECTORY_PROVIDERGROUP_COPY_CONTENT:
      'PHYSICIAN_DIRECTORY_PROVIDERGROUP_COPY_CONTENT',
    PHYSICIAN_DIRECTORY_HOSPITAL_NO_PROVIDER:
      'PHYSICIAN_DIRECTORY_HOSPITAL_NO_PROVIDER',
    PHYSICIAN_DIRECTORY_PROVIDERGROUP_NO_PROVIDER:
      'PHYSICIAN_DIRECTORY_PROVIDERGROUP_NO_PROVIDER',
    NONTIER1_LOCATION_LABEL: 'NONTIER1_LOCATION_LABEL',
    ACCEPTS_MEDICAID_POPOVER_CONTENT: 'ACCEPTS_MEDICAID_POPOVER_CONTENT',
    PRE_EFFECTIVE_ONLINE_SCHEDULE_POPOVER_CONTENT:
      'PRE_EFFECTIVE_ONLINE_SCHEDULE_POPOVER_CONTENT',
    DETAILS_WIDGET_NO_DETAILS_TITLE: 'DETAILS_WIDGET_NO_DETAILS_TITLE',
    DETAILS_WIDGET_NO_DETAILS_SUB_TITLE: 'DETAILS_WIDGET_NO_DETAILS_SUB_TITLE',
    DETAILS_WIDGET_NO_DETAILS_INFO: 'DETAILS_WIDGET_NO_DETAILS_INFO',
    UPCOMING_AVAILABILITY_FILTER_DESCRIPTION:
      'UPCOMING_AVAILABILITY_FILTER_DESCRIPTION',
    BOARD_CERTIFIED_INFO_ICON: 'BOARD_CERTIFIED_INFO_ICON',
    BOARD_CERTIFIED_INFO_TEXT: 'BOARD_CERTIFIED_INFO_TEXT',
    CULTURAL_COMPETENCY_TOOLTIP_INFO_ICON:
      'CULTURAL_COMPETENCY_TOOLTIP_INFO_ICON',
    HCBS_TOOLTIP_INFO_ICON: 'HCBS_TOOLTIP_INFO_ICON',
    PHYSICIAN_DIRECTORY_BH_FACILITY_COPY_CONTENT:
      'PHYSICIAN_DIRECTORY_BH_FACILITY_COPY_CONTENT',
    PHYSICIAN_DIRECTORY_BH_FACILITY_NO_PROVIDER:
      'PHYSICIAN_DIRECTORY_BH_FACILITY_NO_PROVIDER',
    PLAN_TYPE_FILTER_TOOLTIP_CONTENT: 'PLAN_TYPE_FILTER_TOOLTIP_CONTENT',
    PLAN_TYPE_DISABLED_INFO_ICON: 'PLAN_TYPE_DISABLED_INFO_ICON',
    PLAN_TYPE_DISABLED_INFO_TEXT: 'PLAN_TYPE_DISABLED_INFO_TEXT',
    SPECIALTY_OFFERED_TOOLTIP_INFO_ICON: 'SPECIALTY_OFFERED_TOOLTIP_INFO_ICON',
    COST_TAB_COST_ESTIMATES_UPDATED_TEXT:
      'COST_TAB_COST_ESTIMATES_UPDATED_TEXT',
  },
  FEATURE_FLAGS: {
    ENABLE_AGES_TREATED_FILTER: 'ENABLE_AGES_TREATED_FILTER',
    ENABLE_SEARCH_BAR_RECENT_SEARCHES: 'ENABLE_SEARCH_BAR_RECENT_SEARCHES',
    ENABLE_SKIP_MIXED_RESULT_PAGE: 'ENABLE_SKIP_MIXED_RESULT_PAGE',
    ENABLE_NOT_REQUIRED_PCP_INFO: 'ENABLE_NOT_REQUIRED_PCP_INFO',
    ENABLE_OBAPI_MIGRATION: 'ENABLE_OBAPI_MIGRATION',
    ENABLE_SHARED_ACCESS: 'ENABLE_SHARED_ACCESS',
    ENABLE_BH_VIRTUAL_CARE_FILTER_ANALYTICS_V2:
      'ENABLE_BH_VIRTUAL_CARE_FILTER_ANALYTICS_V2',
    REMOVE_COOKIES: 'REMOVE_COOKIES',
    ENABLE_GROUP_NUMBER_BASED_ROUTING: 'ENABLE_GROUP_NUMBER_BASED_ROUTING',
    ENABLE_BROWSE_FOR_CARE: 'ENABLE_BROWSE_FOR_CARE',
    ENABLE_COMMON_PROVIDER_SEARCHES: 'ENABLE_COMMON_PROVIDER_SEARCHES',
    AUTOCOMPLETE_PARALLEL_SEARCHFLOW: 'AUTOCOMPLETE_PARALLEL_SEARCHFLOW',
    BEHAVIORAL_FACILITY_PROGRAMS_FILTER: 'BEHAVIORAL_FACILITY_PROGRAMS_FILTER',
    DEMO_FLAG: 'DEMO',
    REQUEST_RECIPROCITY_ID: 'REQUEST_RECIPROCITY_ID',
    EDUCATIONAL_CONTENT_ENABLED: 'EDUCATIONAL_CONTENT_ENABLED',
    COST_ENABLED: 'COST_ENABLED',
    ENABLE_EAP_FILTER: 'ENABLE_EAP_FILTER',
    BH_FACILITIES_PROGRAMIDS_SECTIONS: 'BH_FACILITIES_PROGRAMIDS_SECTIONS',
    BH_PROGRAMS_DETAILS: 'BH_PROGRAMS_DETAILS',
    SHOW_BEST_MATCH_MODAL: 'SHOW_BEST_MATCH_MODAL',
    SHOW_BEST_MATCH_MODAL_EARLYPAY: 'SHOW_BEST_MATCH_MODAL_EARLYPAY',
    COST_TAB_ENABLED: 'COST_TAB',
    ENABLE_CEX_GET_FULL_COST_ESTIMATE: 'ENABLE_CEX_GET_FULL_COST_ESTIMATE',
    ENABLE_COST_ESTIMATE_IN_CURRENT_TAB: 'ENABLE_COST_ESTIMATE_IN_CURRENT_TAB',
    ENABLE_PRE_PROD: 'ENABLE_PRE_PROD_ENV',
    PRINT_SHARE_DIRECTORY: 'PRINT_SHARE_DIRECTORY',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PREEFFECTIVE_COST_TAB_DISABLED: 'PREEFFECTIVE_COST_TAB_DISABLED',
    SHARE_RECIPIENT_DISABLE: 'SHARE_RECIPIENT_DISABLE',
    THINGS_TO_KNOW_DECEMBER_RLS: 'THINGS_TO_KNOW_DECEMBER_RLS',
    SHARE_PRINT_PDF_REFRESH_FIX: 'SHARE_PRINT_PDF_REFRESH_FIX',
    ENABLE_SEARCH_LOCATION: 'ENABLE_SEARCH_LOCATION',
    AUTOCOMPLETE_CAPTURE_RESULTS: 'AUTOCOMPLETE_CAPTURE_RESULTS',
    UPCOMING_AVAILABILITY: 'UPCOMING_AVAILABILITY',
    ENABLE_COUNTY_SEARCH_ALERT: 'ENABLE_COUNTY_SEARCH_ALERT',
    SHOW_MAP_COLLAPSE: 'SHOW_MAP_COLLAPSE',
    REFERRAL_REQUIRED_BANNER: 'REFERRAL_REQUIRED_BANNER',
    VIRTUAL_CARE_INDICATOR_ENABLED: 'VIRTUAL_CARE_INDICATOR_ENABLED',
    CARE_CATEGORY_CHIPS_TO_TABS_ENABLED: 'CARE_CATEGORY_CHIPS_TO_TABS_ENABLED',
    VISION_CHIP_ENABLED: 'VISION_CHIP_ENABLED',
    DENTAL_CHIP_ENABLED: 'DENTAL_CHIP_ENABLED',
    USE_MEDICAL_NEW_ROLLUP_CODES: 'USE_MEDICAL_NEW_ROLLUP_CODES',
    USE_BH_NEW_ROLLUP_CODES: 'USE_BH_NEW_ROLLUP_CODES',
    USE_DENTAL_NEW_ROLLUP_CODES: 'USE_DENTAL_NEW_ROLLUP_CODES',
    USE_UES_ROLLUP_CODE_FOR_NAME_SEARCH: 'USE_UES_ROLLUP_CODE_FOR_NAME_SEARCH',
    USE_VISION_NEW_ROLLUP_CODES: 'USE_VISION_NEW_ROLLUP_CODES',
    ENABLE_TIERED2_PLAN_FILTER: 'ENABLE_TIERED2_PLAN_FILTER',
    DISABLE_ACO_FILTER: 'DISABLE_ACO_FILTER',
    DISABLE_PREFERRED_FACILITY_FILTER: 'DISABLE_PREFERRED_FACILITY_FILTER',
    ENABLE_VIRTUAL_CARE_BH_FILTER: 'ENABLE_VIRTUAL_CARE_BH_FILTER',
    VISION_WEEKEND_EVENINGS_FILTER_ENABLED:
      'VISION_WEEKEND_EVENINGS_FILTER_ENABLED',
    VISION_RECENT_VISIT: 'VISION_RECENT_VISIT',
    EAP_CODE: 'EAP_CODE',
    ENABLE_DENTAL_LOCATION_NAME: 'ENABLE_DENTAL_LOCATION_NAME',
    TIERED_BENEFITS_ENABLED: 'TIERED_BENEFITS_ENABLED',
    FEATURE_SUPPRESSION: 'FEATURE_SUPPRESSION',
    DENTAL_INTEGRATED_VIEW: 'DENTAL_INTEGRATED_VIEW',
    PREMIUM_CARE: 'PREMIUM_CARE',
    CUSTOM_MESSAGE_NOTIFICATION: 'CUSTOM_MESSAGE_NOTIFICATION',
    ENABLE_LLM: 'ENABLE_LLM',
    TIER_ONE_FILTER_COMPARE: 'TIER_ONE_FILTER_COMPARE',
    PATIENT_REVIEWS_DYNAMIC_HEADER: 'PATIENT_REVIEWS_DYNAMIC_HEADER',
    PREFERRED_FACILITY_IDENTIFICATION: 'PREFERRED_FACILITY_IDENTIFICATION',
    ENABLE_TIER_TWO_PROVIDER: 'ENABLE_TIER_TWO_PROVIDER',
    TRACK_BACK_BUTTON_ENABLED: 'TRACK_BACK_BUTTON_ENABLED',
    ENABLE_INCLUDE_SPEC_CODE_CHANGES: 'ENABLE_INCLUDE_SPEC_CODE_CHANGES',
    ENABLE_CATEGORY_COUNT_V2: 'ENABLE_CATEGORY_COUNT_V2',
    ENABLE_PCP_ALERT_BANNER: 'ENABLE_PCP_ALERT_BANNER',
    ENABLE_EXPRESS_ACCESS_PROVIDER_FILTER:
      'ENABLE_EXPRESS_ACCESS_PROVIDER_FILTER',
    ENABLE_TYPEAHEAD_WILDCARD_SEARCH: 'ENABLE_TYPEAHEAD_WILDCARD_SEARCH',
    ENABLE_TYPEAHEAD_WILDCARD_SEARCH_EARLYPAY:
      'ENABLE_TYPEAHEAD_WILDCARD_SEARCH_EARLYPAY',
    ENABLE_EMPLOYEE_ASSISTANCE_PROGRAM_ACCEPTED_FILTER:
      'ENABLE_EMPLOYEE_ASSISTANCE_PROGRAM_ACCEPTED_FILTER',
    ENABLE_LICENSED_IN_PEDIATRICS_FILTER:
      'ENABLE_LICENSED_IN_PEDIATRICS_FILTER',
    INCLUDE_PROVIDER_GROUP_NAME: 'INCLUDE_PROVIDER_GROUP_NAME',
    GET_PROVIDER_RATINGS: 'PROVIDER_RATINGS',
    GREEN_DIAMOND_IDENTIFICATION: 'GREEN_DIAMOND_IDENTIFICATION',
    GREEN_DIAMOND_PRINT_PDF_IDENTIFICATION:
      'GREEN_DIAMOND_PRINT_PDF_IDENTIFICATION',
    CLEANUP_PROVIDER_CALLS: 'CLEANUP_PROVIDER_CALLS',
    ENABLE_PLAN_SELECTION_V2: 'ENABLE_PLAN_SELECTION_V2',
    BEHAVIORAL_HEALTH_VIRTUAL_CARE: 'BEHAVIORAL_HEALTH_VIRTUAL_CARE',
    ENABLE_LIST_VIEW_MAP_ENHANCEMENTS: 'ENABLE_LIST_VIEW_MAP_ENHANCEMENTS',
    ENABLE_VIRTUALCARE_MIXED_SEARCH_RESULT:
      'ENABLE_VIRTUALCARE_MIXED_SEARCH_RESULT',
    DISABLE_PSX_LINKS_ON_MEMBER_INFO_FAILURE:
      'DISABLE_PSX_LINKS_ON_MEMBER_INFO_FAILURE',
    ENABLE_FILTER_AND_SORT_CTA_MAP_VIEW: 'ENABLE_FILTER_AND_SORT_CTA_MAP_VIEW',
    USP_TIER1_ENABLE: 'USP_TIER1_ENABLE',
    USP_ENABLE: 'USP_ENABLE',
    UNET_NONTIER1_LOCATION: 'UNET_NONTIER1_LOCATION',
    ENABLE_COST_ESTIMATES_NOTIFICATION: 'ENABLE_COST_ESTIMATES_NOTIFICATION',
    ENABLE_MNR_COSMOS: 'ENABLE_MNR_COSMOS',
    ENABLE_CNS: 'ENABLE_CNS',
    ENABLE_IFP: 'ENABLE_IFP',
    OXFORD_PLN: 'OXFORD_PLN',
    DISABLE_TIMESTAMP: 'DISABLE_TIMESTAMP',
    DISABLE_MEDICAL_TIMESTAMP: 'DISABLE_MEDICAL_TIMESTAMP',
    ENABLE_AVAILABILITY_SECTION: 'ENABLE_AVAILABILITY_SECTION',
    ENABLE_REMOVE_ESTIMATED_COST_TEXT: 'ENABLE_REMOVE_ESTIMATED_COST_TEXT',
    SHOW_ISPREEFFECTIVE_INDICATOR: 'SHOW_ISPREEFFECTIVE_INDICATOR',
    SHOW_ACCEPTS_MEDICAID: 'SHOW_ACCEPTS_MEDICAID',
    DISPLAY_FUTURE_TERMINATION_DATE: 'DISPLAY_FUTURE_TERMINATION_DATE',
    ENABLE_DISTANCE_FILTER_SLIDER: 'ENABLE_DISTANCE_FILTER_SLIDER',
    ENHANCE_DISTANCE_FILTER: 'ENHANCE_DISTANCE_FILTER',
    ENABLE_MAP_LOCATION_PIN_HOVER: 'ENABLE_MAP_LOCATION_PIN_HOVER',
    IS_SUPPRESS_PREEFFECTIVE: 'IS_SUPPRESS_PREEFFECTIVE',
    FUTURE_TERMINATION_DEMO: 'FUTURE_TERMINATION_DEMO',
    SHOW_NETWORK_AFFILIATION: 'SHOW_NETWORK_AFFILIATION',
    MEMBER_INFO_POLICY_FILTER: 'MEMBER_INFO_POLICY_FILTER',
    ENABLE_BH_FACILITIES_PROGRAM_SEARCH: 'ENABLE_BH_FACILITIES_PROGRAM_SEARCH',
    FEATURE_INCLUSION: 'FEATURE_INCLUSION',
    ENABLE_BH_AOE_TYPEAHEAD: 'ENABLE_BH_AOE_TYPEAHEAD',
    ENABLE_EAP_FILTER_USING_BH_PROGRAM: 'ENABLE_EAP_FILTER_USING_BH_PROGRAM',
    SHOW_DEPENDENT: 'SHOW_DEPENDENT',
    SHOW_FUTURE_PCP: 'SHOW_FUTURE_PCP',
    SHOW_HCBS_TYPEAHEAD_SUGGESTION: 'SHOW_HCBS_TYPEAHEAD_SUGGESTION',
    ENABLE_SCHEDULE_OPTION: 'ENABLE_SCHEDULE_OPTION',
    ENABLE_SCHEDULING_FOR_DEPENDENT: 'ENABLE_SCHEDULING_FOR_DEPENDENT',
    ONLINE_SCHEDULING: 'ONLINE_SCHEDULING',
    PSX_CTA_DISPLAY_LOGIC: 'PSX_CTA_DISPLAY_LOGIC',
    ENABLE_FIND_ELIGIBLE_PCP_BANNER: 'ENABLE_FIND_ELIGIBLE_PCP_BANNER',
    ENABLE_L2_CULTURAL_COMPETENCIES: 'ENABLE_L2_CULTURAL_COMPETENCIES',
    ENABLE_MOCK_PROVIDER_IDS_FOR_PRE_EFFECTIVE:
      'ENABLE_MOCK_PROVIDER_IDS_FOR_PRE_EFFECTIVE',
    ENABLE_TIER_ONE_MOCK_PROVIDER_IDS: 'ENABLE_TIER_ONE_MOCK_PROVIDER_IDS',
    ENABLE_EXPANDED_SEARCH_RADIUS_BANNER:
      'ENABLE_EXPANDED_SEARCH_RADIUS_BANNER',
    UPCOMING_AVAILABILITY_FOR_MEDICAL: 'UPCOMING_AVAILABILITY_FOR_MEDICAL',
    UPCOMING_AVAILABILITY_FOR_BH: 'UPCOMING_AVAILABILITY_FOR_BH',
    RACE_ETHNICITY: 'RACE_ETHNICITY',
    ENABLE_EXPANDED_SEARCH_RADIUS: 'ENABLE_EXPANDED_SEARCH_RADIUS',
    ENABLE_NAVIGATE_TO_CORRECT_CATEGORY: 'ENABLE_NAVIGATE_TO_CORRECT_CATEGORY',
    ENABLE_CULTURAL_COMPETENCY_TRAINING_SECTION:
      'ENABLE_CULTURAL_COMPETENCY_TRAINING_SECTION',
    ENABLE_CULTURAL_COMPETENCY_CODES_FILTER:
      'ENABLE_CULTURAL_COMPETENCY_CODES_FILTER',
    DISPLAY_IN_NETWORK_BADGE_FUTURE_START_DATE:
      'DISPLAY_IN_NETWORK_BADGE_FUTURE_START_DATE',
    ENABLE_MARKET_PLACE: 'ENABLE_MARKET_PLACE',
    ENABLE_EDIT_PCP_UPDATED_DESIGN: 'ENABLE_EDIT_PCP_UPDATED_DESIGN',
    DISABLE_LINK_WHEN_NO_DATA_MS: 'DISABLE_LINK_WHEN_NO_DATA_MS',
    ENABLE_TIMEMACHINE_TESTING: 'ENABLE_TIMEMACHINE_TESTING',
    ENABLE_TIMEZONE_OFFSET: 'ENABLE_TIMEZONE_OFFSET',
    ENABLE_MIXED_RESULT_PAGE_UPDATED_DESIGN:
      'ENABLE_MIXED_RESULT_PAGE_UPDATED_DESIGN',
    DISABLE_PCP_IND_AND_ANP: 'DISABLE_PCP_IND_AND_ANP',
    DISABLE_PCP_IND_AND_ANP_EARLYPAY: 'DISABLE_PCP_IND_AND_ANP_EARLYPAY',
    ENABLE_RETAIN_STORE_VALUES_IN_SESSION_STORAGE:
      'ENABLE_RETAIN_STORE_VALUES_IN_SESSION_STORAGE',
    ENABLE_REMOVE_SEARCH_PARAMS_IN_URL: 'ENABLE_REMOVE_SEARCH_PARAMS_IN_URL',
    ENABLE_TIMESTAMP_CONTENT: 'ENABLE_TIMESTAMP_CONTENT',
    ENABLE_FREQUENT_SERVICES_PROVIDED: 'ENABLE_FREQUENT_SERVICES_PROVIDED',
    ENABLE_PROVIDER_EXPERIENCE_SECTION: 'ENABLE_PROVIDER_EXPERIENCE_SECTION',
    ENABLE_UES_SUGGESTION_MATCH: 'ENABLE_UES_SUGGESTION_MATCH',
    SHOW_PCP_LAG_TIME_BANNER: 'SHOW_PCP_LAG_TIME_BANNER',
    SHOW_PCP_LAG_TIME_SUCCESS: 'SHOW_PCP_LAG_TIME_SUCCESS',
    ENABLE_SUGGEST_AN_EDIT_FORM: 'ENABLE_SUGGEST_AN_EDIT_FORM',
    ENABLE_BOARD_CERTIFIED_PROVIDERS: 'ENABLE_BOARD_CERTIFIED_PROVIDERS',
    LIMITED_ACCESS_TO_PROVIDER_BANNER_AND_SCHEDULE:
      'LIMITED_ACCESS_TO_PROVIDER_BANNER_AND_SCHEDULE',
    ENABLE_OUTAGE_BANNER: 'ENABLE_OUTAGE_BANNER',
    ENABLE_ALL_FACILITY_ACTIVE_CHECK: 'ENABLE_ALL_FACILITY_ACTIVE_CHECK',
    DISABLE_MEMBER_SELECTOR: 'DISABLE_MEMBER_SELECTOR',
    ENABLE_EXTRACT_PRODUCT_CODE_MARKET_TYPE_FOR_USP_NON_OXFORD:
      'ENABLE_EXTRACT_PRODUCT_CODE_MARKET_TYPE_FOR_USP_NON_OXFORD',
    ENABLE_RETRIVE_TYPEAHEAD_DATA: 'ENABLE_RETRIVE_TYPEAHEAD_DATA',
    ENABLE_RETRIVE_TYPEAHEAD_DATA_MAP_VIEW_PAGE:
      'ENABLE_RETRIVE_TYPEAHEAD_DATA_MAP_VIEW_PAGE',
    ENABLE_SEARCH_RESULTS_V2: 'ENABLE_SEARCH_RESULTS_V2',
    ENABLE_UPDATED_TIME_STAMP_CONTENT: 'ENABLE_UPDATED_TIME_STAMP_CONTENT',
    ENABLE_NOT_AVAILABLE_UNKNOWN_TEXT: 'ENABLE_NOT_AVAILABLE_UNKNOWN_TEXT',
    ENABLE_NEW_REFERRALS_INDICATOR: 'ENABLE_NEW_REFERRALS_INDICATOR',
    ENABLE_KELSEY_SEYBOLD_REFERRAL_BANNER:
      'ENABLE_KELSEY_SEYBOLD_REFERRAL_BANNER',
    ENABLE_LLM_TYPEAHEAD_GENERAL_SEARCH: 'ENABLE_LLM_TYPEAHEAD_GENERAL_SEARCH',
    ENABLE_CRISIS_SUPPORT_SECTION: 'ENABLE_CRISIS_SUPPORT_SECTION',
    ENABLE_NEW_FEEDBACK_FORM_DESIGN: 'ENABLE_NEW_FEEDBACK_FORM_DESIGN',
    ENABLE_NEW_FEEDBACK_FORM_DESIGN_EARLYPAY:
      'ENABLE_NEW_FEEDBACK_FORM_DESIGN_EARLYPAY',
    ENABLE_BROWSE_ALL_FACILITIES_DRAWER: 'ENABLE_BROWSE_ALL_FACILITIES_DRAWER',
    ENABLE_ADVANCED_HOME_TIERING: 'ENABLE_ADVANCED_HOME_TIERING',
    ENABLE_REMOVE_DATE_FROM_PCP_CARD: 'ENABLE_REMOVE_DATE_FROM_PCP_CARD',
    ENABLE_CUSTOM_PREFFERED_PROVIDER_TOGGLE_FILTER:
      'ENABLE_CUSTOM_PREFFERED_PROVIDER_TOGGLE_FILTER',
    ENABLE_ACCOMMODATE_FILTER: 'ENABLE_ACCOMMODATES_FILTER',
    ENABLE_DENTAL_LOCATION_SELECT_MULTIPLE:
      'ENABLE_DENTAL_LOCATION_SELECT_MULTIPLE',
    ENABLE_DENTAL_LOCATION_NAME_FILTER: 'ENABLE_DENTAL_LOCATION_NAME_FILTER',
    ENABLE_HCBS_FACILITY_LOCATION_TAB: 'ENABLE_HCBS_FACILITY_LOCATION_TAB',
    ENABLE_LAGOON_PCP_ERROR_MAP: 'ENABLE_LAGOON_PCP_ERROR_MAP',
    ENABLE_SCHEDULING_WITH_FACILITY_LIMITED_ACCESS_PROVIDERS:
      'ENABLE_SCHEDULING_WITH_FACILITY_LIMITED_ACCESS_PROVIDERS',
    DISABLE_ERROR_PAGE_CALL_CHAT: 'DISABLE_ERROR_PAGE_CALL_CHAT',
    DISABLE_MEDICAL_GROUP_FOR_PCP: 'DISABLE_MEDICAL_GROUP_FOR_PCP',
    ENABLE_THINGS_TO_CONSIDER_MODAL: 'ENABLE_THINGS_TO_CONSIDER_MODAL',
    ENABLE_PSX_PROVIDER_RECOMMENDATIONS: 'ENABLE_PSX_PROVIDER_RECOMMENDATIONS',
    SEDATION_DENTISTRY_SERVICES_PERFORMED:
      'SEDATION_DENTISTRY_SERVICES_PERFORMED',
    ENABLE_VISION_FOR_NON_UHC_MNR: 'ENABLE_VISION_FOR_NON_UHC_MNR',
    ENABLE_ROLECODE_PRIMARY_CARE: 'ENABLE_ROLECODE_PRIMARY_CARE',
    ENABLE_PSX_PRINT: 'ENABLE_PSX_PRINT',
    ENABLE_SPECIALTIES_LOCATION_LEVEL: 'ENABLE_SPECIALTIES_LOCATION_LEVEL',
    ENABLE_MEMBER_INFO_CACHE: 'ENABLE_MEMBER_INFO_CACHE',
    ENABLE_PLATINUM_PROVIDER_IDENTIFIER: 'ENABLE_PLATINUM_PROVIDER_IDENTIFIER',
    CONFIRM_PCP_LOCATION: 'CONFIRM_PCP_LOCATION',
    DISABLE_EAP_FROM_DETAILS_PAGE: 'DISABLE_EAP_FROM_DETAILS_PAGE',
    SHOW_PREMIUM_CARE_CHIP_FILTER: 'SHOW_PREMIUM_CARE_CHIP_FILTER',
    ENABLE_MULTIPLE_BADGE_DATA_CARD_VIEW:
      'ENABLE_MULTIPLE_BADGE_DATA_CARD_VIEW',
    ENABLE_AOE_MEDICAL: 'ENABLE_AOE_MEDICAL',
    ENABLE_TIER1_FROM_MEMBER_RPK: 'ENABLE_TIER1_FROM_MEMBER_RPK',
    ENABLE_SMART_CHOICE_UPDATED_PROVIDER_INFO:
      'ENABLE_SMART_CHOICE_UPDATED_PROVIDER_INFO',
    ENABLE_COMPARE_SMART_CHOICE: 'ENABLE_COMPARE_SMART_CHOICE',
    ENABLE_NON_SMART_CHOICE_DISCLAIMER: 'ENABLE_NON_SMART_CHOICE_DISCLAIMER',
    ENABLE_LLM_MEDICAL_SPECIALISTS: 'ENABLE_LLM_MEDICAL_SPECIALISTS',
    ENABLE_VIEW_MORE_SPECIALTIES_IN_FACILITY_LOCATION_TAB:
      'ENABLE_VIEW_MORE_SPECIALTIES_IN_FACILITY_LOCATION_TAB',
    ENABLE_BH_VIRTUAL_CARE_FILTER_V2: 'ENABLE_BH_VIRTUAL_CARE_FILTER_V2',
    ENABLE_COOKIE_VALIDATION_INTERVAL: 'ENABLE_COOKIE_VALIDATION_INTERVAL',
    DISABLE_MEMBER_SELECTION: 'DISABLE_MEMBER_SELECTION',
    ENABLE_VIRTUAL_VISIT: 'ENABLE_VIRTUAL_VISIT',
    ENABLE_MAP_PIN_REDESIGN: 'ENABLE_MAP_PIN_REDESIGN',
    ENABLE_MAP_DRAG_REFRESH_RESULTS: 'ENABLE_MAP_DRAG_REFRESH_RESULTS',
    ENABLE_MAP_VIEW_LARGE_RESULTS: 'ENABLE_MAP_VIEW_LARGE_RESULTS',
    ENABLE_MEMBER_DEFAULT_LOCATION: 'ENABLE_MEMBER_DEFAULT_LOCATION',
    PING_FEDERATE: 'PING_FEDERATE',
    ENABLE_LOCATION_SEARCH_TEXTBOX_ICON: 'ENABLE_LOCATION_SEARCH_TEXTBOX_ICON',
    ENABLE_RECOMMENDATION_AUDIT_MODAL: 'ENABLE_RECOMMENDATION_AUDIT_MODAL',
    ENABLE_ALPHA_SORT_OPTION: 'ENABLE_ALPHA_SORT_OPTION',
    ENABLE_PREMIUM_PROVIDER_BADGE_NEW_DISPLAY:
      'ENABLE_PREMIUM_PROVIDER_BADGE_NEW_DISPLAY',
    ENABLE_FACILITY_DETAILS_ANALYTICS: 'ENABLE_FACILITY_DETAILS_ANALYTICS',
    ENABLE_PING_FEDERATE_VC: 'ENABLE_PING_FEDERATE_VC',
    ENABLE_PVC_CHECK_DETAILS_WIDGET: 'ENABLE_PVC_CHECK_DETAILS_WIDGET',
    DISABLE_CRISIS_KEYWORDS_CTA_SUPPORT_FINDER:
      'DISABLE_CRISIS_KEYWORDS_CTA_SUPPORT_FINDER',
    CHANGE_ROLLUP_CODE_LOGIC_VC: 'CHANGE_ROLLUP_CODE_LOGIC_VC',
    SUPPRESS_TYPEAHEAD_BH_TAG: 'SUPPRESS_TYPEAHEAD_BH_TAG',
    SUPPRESS_PCP_SELECTION_COMMIT: 'SUPPRESS_PCP_SELECTION_COMMIT',
    PROVIDER_ID_WITH_ADDRESS_ID: 'PROVIDER_ID_WITH_ADDRESS_ID',
    DISABLE_PCP_DETAILS_IF_OUT_OF_DIRECTORY:
      'DISABLE_PCP_DETAILS_IF_OUT_OF_DIRECTORY',
    ENABLE_OUT_OF_STATE_VIRTUAL_PROVIDERS:
      'ENABLE_OUT_OF_STATE_VIRTUAL_PROVIDERS',
    ENABLE_STATE_LICENSE_SECTION: 'ENABLE_STATE_LICENSE_SECTION',
    ENABLE_HCP_VIRTUAL_CARE_ELIGIBILITY: 'ENABLE_HCP_VIRTUAL_CARE_ELIGIBILITY',
    ENABLE_MAP_VIEW_HIDE_OPTION: 'ENABLE_MAP_VIEW_HIDE_OPTION',
    ENABLE_LIST_VIEW_HEADER_STICKY: 'ENABLE_LIST_VIEW_HEADER_STICKY',
    DISPLAY_LIST_VIEW_FIRST: 'DISPLAY_LIST_VIEW_FIRST',
    ENABLE_ENHANCED_PDF_PRINT_BH_FACILITY:
      'ENABLE_ENHANCED_PDF_PRINT_BH_FACILITY',
    ENABLE_PLATINUM_PROVIDER_IDENTIFIER_ANALYTICS:
      'ENABLE_PLATINUM_PROVIDER_IDENTIFIER_ANALYTICS',
    ENABLE_FONT_HEADER_MAP_VIEW: 'ENABLE_FONT_HEADER_MAP_VIEW',
    ENABLE_PLATINUM_PROGRAM_FILTER: 'ENABLE_PLATINUM_PROGRAM_FILTER',
    ENABLE_ENHANCED_PDF_PRINT_BH_PROVIDERS:
      'ENABLE_ENHANCED_PDF_PRINT_BH_PROVIDERS',
    SHOW_DEFAULT_SEARCH_RADIUS_POPOVER_MSG:
      'SHOW_DEFAULT_SEARCH_RADIUS_POPOVER_MSG',
    SHOW_UPCOMING_AVAILABILITY_POPOVER_MSG_FOR_BH:
      'SHOW_UPCOMING_AVAILABILITY_POPOVER_MSG_FOR_BH',
    ENABLE_PROVIDER_DIRECTORY_FOR_BH_FACILITY:
      'ENABLE_PROVIDER_DIRECTORY_FOR_BH_FACILITY',
    SUPPRESS_SPECIALTY_SECTION_FOR_PROVIDER_GROUP_BH:
      'SUPPRESS_SPECIALTY_SECTION_FOR_PROVIDER_GROUP_BH',
    USE_PARSED_LAGOON_CONTENT_FOR_NULL_PAGE_LAGOON_CONTENT:
      'USE_PARSED_LAGOON_CONTENT_FOR_NULL_PAGE_LAGOON_CONTENT',
    ENABLE_ACCREDITATION_FILTER: 'ENABLE_ACCREDITATION_FILTER',
    ENABLE_SMART_CHOICE_QUALITY_LLM_STATUS:
      'ENABLE_SMART_CHOICE_QUALITY_LLM_STATUS',
    ENABLE_BOARD_CERTIFIED_PROVIDERS_BH: 'ENABLE_BOARD_CERTIFIED_PROVIDERS_BH',
    ENABLE_PCP_PARAMS_FROM_URL: 'ENABLE_PCP_PARAMS_FROM_URL',
    ENABLE_PROVIDER_DETAILS_AND_REVIEWS_FROM_PARAMS:
      'ENABLE_PROVIDER_DETAILS_AND_REVIEWS_FROM_PARAMS',
    ENABLE_CARE_TEAM_VIEW: 'ENABLE_CARE_TEAM_VIEW',
    ENABLE_PICK_UP_WHERE_YOU_LEFT_OFF: 'ENABLE_PICK_UP_WHERE_YOU_LEFT_OFF',
    ENABLE_SORT_UPCOMING_AVAILABILITY: 'ENABLE_SORT_UPCOMING_AVAILABILITY',
    RESULT_PAGE_CUSTOM_SORT: 'RESULT_PAGE_CUSTOM_SORT',
    RESULT_PAGE_CUSTOM_SORT_EARLYPAY: 'RESULT_PAGE_CUSTOM_SORT_EARLYPAY',
    ENABLE_RIGHT_CLICK_MENU: 'ENABLE_RIGHT_CLICK_MENU',
    ENABLE_RECOMMENDATION_PRICE_CARE: 'ENABLE_RECOMMENDATION_PRICE_CARE',
    ENABLE_SEARCH_RELEVANCY_EVENTS_DASHBOARD:
      'ENABLE_SEARCH_RELEVANCY_EVENTS_DASHBOARD',
    ENABLE_BURMESE_LANGUAGE: 'ENABLE_BURMESE_LANGUAGE',
    ENABLE_CREOLE_LANGUAGE: 'ENABLE_CREOLE_LANGUAGE',
    ENABLE_TRADITIONAL_CHINESE_LANGUAGE: 'ENABLE_TRADITIONAL_CHINESE_LANGUAGE',
    ENABLE_VIETNAMESE_LANGUAGE: 'ENABLE_VIETNAMESE_LANGUAGE',
    ENABLE_ILOCANO_LANGUAGE: 'ENABLE_ILOCANO_LANGUAGE',
    ENABLE_KOREAN_LANGUAGE: 'ENABLE_KOREAN_LANGUAGE',
    ENABLE_PHONE_NUMBER_SEARCH: 'ENABLE_PHONE_NUMBER_SEARCH',
    AUTOCOMPLETE_ERROR_MESSAGE: 'AUTOCOMPLETE_ERROR_MESSAGE',
    ENABLE_NPI_SEARCH: 'ENABLE_NPI_SEARCH',
    ENABLE_LICENSE_SEARCH: 'ENABLE_LICENSE_SEARCH',
    ENABLE_PLAN_TYPE_SELECTION_IN_FILTER:
      'ENABLE_PLAN_TYPE_SELECTION_IN_FILTER',
    SHOW_PROVIDER_NETWORK_INFO: 'SHOW_PROVIDER_NETWORK_INFO',
    SHOW_DEFAULT_SEARCH_RADIUS_POPOVER_MSG_FOR_BH:
      'SHOW_DEFAULT_SEARCH_RADIUS_POPOVER_MSG_FOR_BH',
    WIGS_FILTER_ENABLE: 'WIGS_FILTER_ENABLE',
    ENABLE_RR_VIRTUAL_CARE_CEX_WIDGET: 'ENABLE_RR_VIRTUAL_CARE_CEX_WIDGET',
    ENABLE_NON_ENGLISH_CHARACTERS_TYPEAHEAD:
      'ENABLE_NON_ENGLISH_CHARACTERS_TYPEAHEAD',
    ENABLE_COLOR_CODED_SPECIALTIES: 'ENABLE_COLOR_CODED_SPECIALTIES',
    QUICK_CARE_GUEST: 'QUICK_CARE_GUEST',
    ENABLE_SMART_CHOICE_INTRO_POPUP: 'ENABLE_SMART_CHOICE_INTRO_POPUP',
    ENABLE_VIRTUAL_CARE_EPIC: 'ENABLE_VIRTUAL_CARE_EPIC',
    ENABLE_PRIMARY_VIRTUAL_CARE: 'ENABLE_PRIMARY_VIRTUAL_CARE',
    THEME_GEHA: 'THEME_GEHA',
    ENABLE_CHAT_FOR_PROXY_USERS: 'ENABLE_CHAT_FOR_PROXY_USERS',
    ENABLE_AFTER_HOURS_PHONE: 'ENABLE_AFTER_HOURS_PHONE',
    SHOW_MARKETPLACE_BH_FORCED: 'SHOW_MARKETPLACE_BH_FORCED',
    DISABLE_SEARCH_BAR: 'DISABLE_SEARCH_BAR',
    DISABLE_EAP_TYPEAHEAD_FOR_NON_EAP_CLIENT:
      'DISABLE_EAP_TYPEAHEAD_FOR_NON_EAP_CLIENT',
    ENABLE_ADDITIONAL_REPORTING_RESOURCES:
      'ENABLE_ADDITIONAL_REPORTING_RESOURCES',
    ENABLE_VIRTUAL_CARE_PROVIDERS_MAP_RESULT_PAGE:
      'ENABLE_VIRTUAL_CARE_PROVIDERS_MAP_RESULT_PAGE',
    ENABLE_SC_APPOINTMENT_AVAILABILITY: 'ENABLE_SC_APPOINTMENT_AVAILABILITY',
    ENABLE_VIRTUAL_CARE_PROVIDERS_IN_TYPEAHEAD:
      'ENABLE_VIRTUAL_CARE_PROVIDERS_IN_TYPEAHEAD',
    SMART_CHOICE_SUPPRESS_OHPD_SPECIALTY:
      'SMART_CHOICE_SUPPRESS_OHPD_SPECIALTY',
    ENABLE_COUNTY_LABEL_IN_LOCATION_POPOVER:
      'ENABLE_COUNTY_LABEL_IN_LOCATION_POPOVER',
    DISABLE_WHERE_TO_GET_HELP: 'DISABLE_WHERE_TO_GET_HELP',
    ENABLE_CLAIMS_BASED_LLM_ALL_LANGUAGES:
      'ENABLE_CLAIMS_BASED_LLM_ALL_LANGUAGES',
    ASCENSION_INDICATOR_ENABLE: 'ASCENSION_INDICATOR_ENABLE',
    ENABLE_NEW_UX_SMART_CHOICE_ANALYTICS:
      'ENABLE_NEW_UX_SMART_CHOICE_ANALYTICS',
    ENABLE_PROVIDER_AI_BIO_API: 'ENABLE_PROVIDER_AI_BIO_API',
    ENABLE_FACILITY_AI_BIO_UI: 'ENABLE_FACILITY_AI_BIO_UI',
    ENABLE_PROVIDER_AI_BIO_UI: 'ENABLE_PROVIDER_AI_BIO_UI',
    ENABLE_BCC_FILTER: 'ENABLE_BCC_FILTER',
    ENABLE_NEW_COMPARE_POPOVER_FLOW: 'ENABLE_NEW_COMPARE_POPOVER_FLOW',
    GUEST_TYPEAHEAD_COVERAGE_LINK: 'GUEST_TYPEAHEAD_COVERAGE_LINK',
    SHOW_PRIORITY_SCHEDULING_POPOVER_MSG:
      'SHOW_PRIORITY_SCHEDULING_POPOVER_MSG',
    ENABLE_BCC_TOAST: 'ENABLE_BCC_TOAST',
    AUTOCOMPLETE_TAGGING_CHANGES: 'AUTOCOMPLETE_TAGGING_CHANGES',
    ENABLE_PROVIDER_BCC_BADGE: 'ENABLE_PROVIDER_BCC_BADGE',
    ENABLE_ASCENSION_ANALYTICS: 'ENABLE_ASCENSION_ANALYTICS',
    ENABLE_ANP_FOR_FACILITIES: 'ENABLE_ANP_FOR_FACILITIES',
    ENABLE_GUEST_HEADER: 'ENABLE_GUEST_HEADER',
    GUEST_START_MODAL_ENABLED: 'GUEST_START_MODAL_ENABLED',
    GUEST_FIRST_TIME_USER_BANNERS_ENABLED:
      'GUEST_FIRST_TIME_USER_BANNERS_ENABLED',
    GUEST_SCHEDULE_SIGN_IN_MODAL: 'GUEST_SCHEDULE_SIGN_IN_MODAL',
  },
  MEDICAL_SPECIALISTS: {
    HOW_TO_GET_REFERRAL_CARD: 'HOW_TO_GET_REFERRAL',
    TIER_ONE_BENEFITS_ONE: 'TIER_ONE_BENEFITS_ONE',
  },
  VIRTUAL_VISIT: {
    VIRTUAL_VISIT_COST: 'VIRTUAL_VISIT_COST',
    VIRTUAL_VISIT_LANDING_PAGE: 'VIRTUAL_VISIT_LANDING_PAGE',
    VIRTUAL_VISIT_LANDING_PAGE_LIST_CONTENT:
      'VIRTUAL_VISIT_LANDING_PAGE_LIST_CONTENT',
    VIRTUAL_VISIT_PROVIDERS: 'VIRTUAL_VISIT_PROVIDERS',
    VIRTUAL_VISIT_DISCLAIMER: 'VIRTUAL_VISIT_DISCLAIMER',
    VIRTUAL_VISIT_VIEW_ALL: 'VIRTUAL_VISIT_VIEW_ALL',
    ONDEMAND_SCHEDULED_APPOINTMENTS_AVAILABLE:
      'ONDEMAND_SCHEDULED_APPOINTMENTS_AVAILABLE',
    VIRTUAL_VISIT_GOOD_FOR: 'VIRTUAL_VISIT_GOOD_FOR',
  },
  VIRTUAL_CARE: {
    VIRTUAL_URGENT_CARE_COST_ESTIMATE: 'VIRTUAL_URGENT_CARE_COST_ESTIMATE',
    VIRTUAL_URGENT_CARE_LANDING_PAGE: 'VIRTUAL_URGENT_CARE_LANDING_PAGE',
    VIRTUAL_URGENT_CARE_LANDING_PAGE_LIST_CONTENT:
      'VIRTUAL_URGENT_CARE_LANDING_PAGE_LIST_CONTENT',
    VIRTUAL_URGENT_CARE_DISCLAIMER: 'VIRTUAL_URGENT_CARE_DISCLAIMER',
    VIRTUAL_URGENT_CARE_GOOD_FOR: 'VIRTUAL_URGENT_CARE_GOOD_FOR',
    ENABLE_VIRTUAL_URGENT_CARE: 'ENABLE_VIRTUAL_URGENT_CARE',
    VIRTUAL_URGENT_CARE_CARD_DESCRIPTION:
      'VIRTUAL_URGENT_CARE_CARD_DESCRIPTION',
    VIRTUAL_PRIMARY_CARE_CARD_DESCRIPTION:
      'VIRTUAL_PRIMARY_CARE_CARD_DESCRIPTION',
    VIRTUAL_PRIMARY_CARE_INFO: 'VIRTUAL_PRIMARY_CARE_INFO',
    VIRTUAL_CARE_CARD_CTA: 'VIRTUAL_CARE_CARD_CTA',
    VIRTUAL_PRIMARY_CARE_LANDING_PAGE: 'VIRTUAL_PRIMARY_CARE_LANDING_PAGE',
    VIRTUAL_PRIMARY_CARE_LANDING_PAGE_LIST_CONTENT:
      'VIRTUAL_PRIMARY_CARE_LANDING_PAGE_LIST_CONTENT',
    VIRTUAL_PRIMARY_CARE_GOOD_FOR: 'VIRTUAL_PRIMARY_CARE_GOOD_FOR',
    VIRTUAL_PRIMARY_CARE_COST_ESTIMATE: 'VIRTUAL_PRIMARY_CARE_COST_ESTIMATE',
    ENABLE_VIRTUAL_PRIMARY_CARE: 'ENABLE_VIRTUAL_PRIMARY_CARE',
    ENABLE_VIRTUAL_SPECIALTY_CARE: 'ENABLE_VIRTUAL_SPECIALTY_CARE',
    VIRTUAL_SPECIALTY_CARE_LANDING_PAGE: 'VIRTUAL_SPECIALTY_CARE_LANDING_PAGE',
    ENABLE_VIRTUAL_PROVIDERS_SECTION: 'ENABLE_VIRTUAL_PROVIDERS_SECTION',
    VIRTUAL_PROVIDERS_SECTION_CONTENT: 'VIRTUAL_PROVIDERS_SECTION_CONTENT',
    VIRTUAL_PROVIDER_SECTION_LIST_CONTENT:
      'VIRTUAL_PROVIDER_SECTION_LIST_CONTENT',
    VIRTUAL_CARE_COST_ESTIMATE_MESSAGE: 'VIRTUAL_CARE_COST_ESTIMATE_MESSAGE',
    VIRTUAL_SPECIALTY_CARE_COST_ESTIMATE:
      'VIRTUAL_SPECIALTY_CARE_COST_ESTIMATE',
  },
  BEHAVIORAL_HEALTH: {
    TITLE_KEY: 'TITLE',
    CONTENT_KEY: 'CONTENT',
    TALK_TO_NURSE_CARD_INFO: 'TALK_TO_NURSE_CARD_INFO',
  },
  PRIMARY_CARE: {
    PRIMARY_CARE_PROVIDERS: 'PRIMARY_CARE_PROVIDERS',
    PRIMARY_CARE_LOCATIONS: 'PRIMARY_CARE_LOCATIONS',
    PRIMARY_CARE_CLINICS: 'PRIMARY_CARE_CLINICS',
    PRIMARY_CARE_MEDICAL_GROUPS: 'PRIMARY_CARE_MEDICAL_GROUPS',
    TIER_ONE_PROVIDER: 'TIER_ONE_PROVIDER',
    TIERED_BENEFITS: 'TIERED_BENEFITS',
    PCP_NOT_CHOSEN_ELIGIBILITY: 'PCP_NOT_CHOSEN_ELIGIBILITY',
    PCP_NOT_CHOSEN_ACCEPTANCE: 'PCP_NOT_CHOSEN_ACCEPTANCE',
    NO_PCP_MESSAGE: 'NO_PCP_MESSAGE',
    PCP_WILL_BE_ASSIGNED_SUBSCRIBER: 'PCP_WILL_BE_ASSIGNED_SUBSCRIBER',
    PCP_WILL_BE_ASSIGNED_DEPENDENT: 'PCP_WILL_BE_ASSIGNED_DEPENDENT',
    CHOOSE_PCP_BY: 'CHOOSE_PCP_BY',
    CHOOSE_PCP_SOON: 'CHOOSE_PCP_SOON',
    PCP_NOT_REQUIRED_INFO: 'PCP_NOT_REQUIRED_INFO',
    CHOOSE_PCP_BUTTON: 'CHOOSE_PCP_BUTTON',
    CHOOSE_PCP_MESSAGE_ON_CARE_TEAM_CARD:
      'CHOOSE_PCP_MESSAGE_ON_CARE_TEAM_CARD',
    CHOOSE_PCP_SOON_CARE_TEAM: 'CHOOSE_PCP_SOON_CARE_TEAM',
    CHOOSE_PCP_BY_CARE_TEAM: 'CHOOSE_PCP_BY_CARE_TEAM',
  },
  SHARE_THIS_PROVIDER: {
    SHARE_THIS_PROVIDER_MESSAGE: 'SHARE_THIS_PROVIDER_MESSAGE',
  },
  VALID_EMAIL_ADDRESS: {
    VALID_EMAIL_ADDRESS_MESSAGE: 'VALID_EMAIL_ADDRESS_MESSAGE',
  },
  SEARCH_LABEL: 'SEARCH_LABEL',
  SEARCH_LABEL_IFP_EARLYPAY: 'SEARCH_LABEL_IFP_EARLYPAY',
  LOCATION_LABEL: 'LOCATION_LABEL',
  SUGGESTED_PROVIDERS: {
    SUGGESTED_PROVIDERS_MESSAGE: 'SUGGESTED_PROVIDERS_MESSAGE',
  },
  HEALTHGRADES: {
    MODAL_DISCLAIMER_SHORT: 'HEALTH_GRADES_DISCLAIMER_CONTENT',
    MODAL_DISCLAIMER_FULL: 'HEALTH_GRADES_DISCLAIMER_POPUP',
    DISCLAIMER_IN_PAGE: 'HEALTH_GRADES_IN_PAGE',
    PRINT_VIEW_CONTENT: 'HEALTH_GRADES_PRINT_VIEW_CONTENT',
    CNS_DISCLAIMER_FOR_NOT_INCLUSION_STATES:
      'CNS_DISCLAIMER_FOR_NOT_INCLUSION_STATES',
  },
  DENTAL: {
    TITLE_KEY: 'TITLE',
  },
  VISION: {
    TITLE_KEY: 'TITLE',
    VISION_PAGE_TALK_TO_NURSE_TOGGLE: 'VISION_PAGE_TALK_TO_NURSE_TOGGLE',
  },
  EDUCATIONAL_CONTENT_MODAL: {
    EDUCATIONAL_CONTENT_MODAL_TITLE: 'EDUCATIONAL_CONTENT_MODAL_TITLE',
    EDUCATIONAL_CONTENT_MODAL_DESCRIPTION:
      'EDUCATIONAL_CONTENT_MODAL_DESCRIPTION',
  },
  SAVE_PROVIDER_LOCATION_MODAL: {
    SAVE_PROVIDER_LOCATION_MODAL_CONTENT:
      'SAVE_PROVIDER_LOCATION_MODAL_CONTENT',
  },
  SAVE_PROVIDER_TOAST: {
    SAVE_PROVIDER_TOAST_MESSAGE: 'SAVE_PROVIDER_TOAST_MESSAGE',
  },
  OUTAGE_BANNER: {
    ENABLE_OUTAGE_BANNER_MESSAGE: 'ENABALE_OUATGE_BANNER_MESSAGE',
  },

  REMOVE_PROVIDER_TOAST: {
    REMOVE_PROVIDER_TOAST_MESSAGE: 'REMOVE_PROVIDER_TOAST_MESSAGE',
  },

  UPDATE_PROVIDER_TOAST: {
    UPDATE_PROVIDER_TOAST_MESSAGE: 'UPDATE_PROVIDER_TOAST_MESSAGE',
  },

  VIRTUAL_CARE_PROVIDERS_BANNER: {
    VIRTUAL_CARE_PROVIDERS_BANNER_CONTENT:
      'VIRTUAL_CARE_PROVIDERS_BANNER_CONTENT',
    VIRTUAL_CARE_PROVIDER_MODAL_CONTENT: 'VIRTUAL_CARE_PROVIDER_MODAL_CONTENT',
    VIRTUAL_CARE_PROVIDERS_BANNER_LINK: 'VIRTUAL_CARE_PROVIDERS_BANNER_LINK',
  },

  LANGUAGE_MODAL: {
    LANGUAGE_NOT_AVAILABLE: 'LANGUAGE_NOT_AVAILABLE',
    LANGUAGE_NOT_AVAILABLE_CONTENT: 'LANGUAGE_NOT_AVAILABLE_CONTENT',
  },
  COST_INDICATOR_CONTENT_MODAL: {
    COST_INDICATOR_POPOVER_CONTENT: 'COST_INDICATOR_POPOVER_CONTENT',
  },
  NATIONAL_ANCILLARY_NO_LOCATION_MODAL: 'NATIONAL_ANCILLARY_NO_LOCATION_MODAL',
  ONLINE_PROVIDERS_VISION_NO_LOCATION_MODAL:
    'ONLINE_PROVIDERS_VISION_NO_LOCATION_MODAL',
  MEMBER_SELECTION_CONFIRMATION_MODAL: {
    MEMBER_SELECTION_MODAL_BODY_CONTENT: 'MEMBER_SELECTION_MODAL_BODY_CONTENT',
    MEMBER_SELECTION_MODAL_BODY_HEADER: 'MEMBER_SELECTION_MODAL_BODY_HEADER',
    MEMBER_SELECTION_MODAL_PCP_CONTENT: 'MEMBER_SELECTION_MODAL_PCP_CONTENT',
    MEMBER_SELECTION_MODAL_CARE_SECTION_CONTENT:
      'MEMBER_SELECTION_MODAL_CARE_SECTION_CONTENT',
    MEMBER_SELECTION_MODAL_SCHEDULING_SECTION_CONTENT:
      'MEMBER_SELECTION_MODAL_SCHEDULING_SECTION_CONTENT',
  },
  NO_PROVIDERS_FOUND: 'NO_PROVIDERS_FOUND',
  FEATURE_SUPPRESSION_FLAGS: {
    PREMIUM_CARE: 'Premium Care',
    PATIENT_REVIEWS: 'Patient Reviews',
    PREFERRED_FACILITY: 'Preferred Facility',
    DDP: 'DDP',
    PLN: 'PLN',
    FSF: 'FSF',
    EAP: 'EAP',
    CUSTOM_PREFERRED_POLICY: 'Custom Preferred Policy',
    COST_ESTIMATES: 'Cost Estimates',
    COST_ESTIMATES_EMPIRE: 'Cost Estimates Empire',
    SUPPRESS_COST_ESTIMATES_FROM_COST_TAB:
      'Suppress Cost Estimates From Cost Tab',
    VIRTUAL_CARE_EMPIRE: 'Virtual Care Empire',
    VIRTUAL_CARE_TOGGLE_SWITCH_PROVIDER_GROUP:
      'Virtual Care Toggle Switch Provider Group',
    SUPPRESS_DOC_ASAP: 'Suppress Doc ASAP',
    MARKET_PLACE: 'Market Place',
    VIRTUAL_CARE_UNET_RAILROAD: 'Virtual Care UNET Railroad',
    VIRTUAL_CARE_UNET: 'Virtual Care UNET',
    VIRTUAL_CARE_UNET_QUICK_CARE: 'Virtual Care UNET Quick Care',
    VIRTUAL_CARE_UNET_CARE_TEAM_CARD_SUPPRESSION:
      'Virtual Care UNET Care Team Card Suppression',
    VIRTUAL_CARE_UNET_FILTER_SUPPRESSION:
      'Virtual Care UNET Filter Suppression',
    VIRTUAL_ONLY_LOCATION_INDICATOR_UNET_RAILROAD:
      'Virtual Only Location Indicator UNET Railroad',
    SUPPRESS_BH_VIRTUAL_CARE_UNET_RR_SUGGESTIONS:
      'Suppress BH Virtual Care UNET Railroad Suggestions',
    SUPPRESS_MEDICAL_VIRTUAL_CARE_UNET_RR_SUGGESTIONS:
      'Suppress Medical Virtual Care UNET Railroad Suggestions',
    BEHAVIORAL_HEALTH: 'Behavioral Health',
    SMART_CHOICE: 'Smart Choice',
    GENDER_AFFIRMING_AOE_CODES: 'Gender Affirming AOE Codes',
  },
  FEATURE_INCLUSION_FLAGS: {
    INCLUDE_DOC_ASAP: 'DocASAP',
    INCLUDE_CNS_OH: 'C&S Ohio',
    AFTER_HRS_VISIBILITY_STATES: 'AFTER_HRS_VISIBILITY_STATES',
    AI_BIO_ELIGIBILITY_STATES: 'AiBioEligibility_State',
  },
  EAP_AUTHORIZATION_CODE: 'EAP_AUTHORIZATION_CODE',
  PREFERRED_FACILITY: {
    PREFERRED_FACILITY_IDENTIFICATION: 'PREFERRED_FACILITY_IDENTIFICATION',
    PREFERRED_FACILITY_CONTENT: 'PREFERRED_FACILITY_CONTENT',
    DESIGNATED_DIAGNOSTIC_PROVIDER_CONTENT:
      'DESIGNATED_DIAGNOSTIC_PROVIDER_CONTENT',
    PREFERRED_LAB_NETWORK_CONTENT: 'PREFERRED_LAB_NETWORK_CONTENT',
    FREESTANDING_FACILITY_CONTENT: 'FREESTANDING_FACILITY_CONTENT',
    OXFORD_PREFERRED_LAB_CONTENT: 'OXFORD_PREFERRED_LAB_CONTENT',
  },
  MIXED_SEARCH_RESULT_PAGE: {
    SEARCH_SPECIALITY_RESULTS: 'SEARCH_SPECIALITY_RESULTS',
    SEARCH_NAME_RESULTS: 'SEARCH_NAME_RESULTS',
    SEARCH_SPECIALITY_RESULTS_SUBTITLE: 'SEARCH_SPECIALITY_RESULTS_SUBTITLE',
    SEARCH_NAME_RESULTS_SUBTITLE: 'SEARCH_NAME_RESULTS_SUBTITLE',
    SEARCH_INSTEAD_FOR_HEADING: 'SEARCH_INSTEAD_FOR_HEADING',
    SEARCH_RESULT_TITLE: 'SEARCH_RESULT_TITLE',
    SEARCH_PREFERRED_FACILITY_RESULTS_SUBTITLE:
      'SEARCH_PREFERRED_FACILITY_RESULTS_SUBTITLE',
  },
  PREFERRED_PROVIDER: {
    PREFERRED_PROVIDER_CONTENT: 'PREFERRED_PROVIDER_CONTENT',
  },
  TYPEAHEAD_PARAMS: {
    USER_TEXT_SEARCH_LABEL: 'USER_TEXT_SEARCH_LABEL',
  },
  LEAPFROG: {
    LEAPFROG_DISCLAIMER_CONTENT: 'LEAPFROG_DISCLAIMER_CONTENT',
  },
  CHOOSE_PCP_FLOW: {
    NEW_PATIENT_DISCLAIMER: 'NEW_PATIENT_DISCLAIMER',
  },
  VISION_DICTIONARY: {
    DISCLAIMER_CONTENT: 'VISION_DICTIONARY_DISCLAIMER_CONTENT',
    DISCLAIMER_ADDL_CONTENT: 'VISION_DICTIONARY_DISCLAIMER_ADDL_CONTENT',
  },
  MNR_DISCLAIMER: {
    DENTAL_MNR_DISCLAIMER: 'DENTAL_MNR_DISCLAIMER',
    MEDICAL_FACILITY_MNR_DISCLAIMER: 'MEDICAL_FACILITY_MNR_DISCLAIMER',
    VISION_MNR_DISCLAIMER: 'VISION_MNR_DISCLAIMER',
    HEALTH_GRADES_MNR_DISCLAIMER_CONTENT:
      'HEALTH_GRADES_MNR_DISCLAIMER_CONTENT',
    DIRECTORY_MNR_DISCLAIMER: 'DIRECTORY_MNR_DISCLAIMER',
  },
  THINGS_TO_CONSIDER: {
    THINGS_TO_CONSIDER_SECTION_ONE_TITLE:
      'THINGS_TO_CONSIDER_SECTION_ONE_TITLE',
    THINGS_TO_CONSIDER_SECTION_ONE_CONTENT:
      'THINGS_TO_CONSIDER_SECTION_ONE_CONTENT',
    THINGS_TO_CONSIDER_SECTION_TWO_TITLE:
      'THINGS_TO_CONSIDER_SECTION_TWO_TITLE',
    THINGS_TO_CONSIDER_SECTION_TWO_CONTENT:
      'THINGS_TO_CONSIDER_SECTION_TWO_CONTENT',
    THINGS_TO_CONSIDER_SECTION_THREE_CONTENT:
      'THINGS_TO_CONSIDER_SECTION_THREE_CONTENT',
    THINGS_TO_CONSIDER_SECTION_THREE_TITLE:
      'THINGS_TO_CONSIDER_SECTION_THREE_TITLE',
    THINGS_TO_CONSIDER_TITLE: 'THINGS_TO_CONSIDER_TITLE',
    THINGS_TO_CONSIDER_TITLE_CHOOSE_PCP: 'THINGS_TO_CONSIDER_TITLE_CHOOSE_PCP',
    THINGS_TO_CONSIDER_SUBTITLE: 'THINGS_TO_CONSIDER_SUBTITLE',
    THINGS_TO_CONSIDER_SUBTITLE_CHOOSE_PCP:
      'THINGS_TO_CONSIDER_SUBTITLE_CHOOSE_PCP',
  },
  PCP_CHANGE_MESSAGE: {
    PCP_MESSAGE_FOR_LAG_TIME: 'PCP_MESSAGE_FOR_LAG_TIME',
    PCP_SUCCESS_MESSAGE: 'PCP_SUCCESS_MESSAGE',
    PCP_CARD_MESSAGE_FOR_LAG_TIME: 'PCP_CARD_MESSAGE_FOR_LAG_TIME',
  },
  CHOOSE_A_PCP_POPOVER_CONTENT: {
    POPOVER_CONTENT_HEADING: 'POPOVER_CONTENT_HEADING',
    POPOVER_CONTENT_SUB_HEADING: 'POPOVER_CONTENT_SUB_HEADING',
    POPOVER_CONTENT_CONTENT_LIST_ONE: 'POPOVER_CONTENT_CONTENT_LIST_ONE',
    POPOVER_CONTENT_CONTENT_LIST_TWO: 'POPOVER_CONTENT_CONTENT_LIST_TWO',
    POPOVER_CONTENT_CONTENT_LIST_THREE: 'POPOVER_CONTENT_CONTENT_LIST_THREE',
    POPOVER_CONTENT_CHOOSE_PCP: 'POPOVER_CONTENT_CHOOSE_PCP',
  },
  UI_MESSAGING: {
    VIRTUAL_CARE_COST_ESTIMATE_MESSAGE: 'VIRTUAL_CARE_COST_ESTIMATE_MESSAGE',
    GROUP_RESULTS_MESSAGING: 'GROUP_RESULTS_MESSAGING',
    TIME_STAMP_LABEL: 'TIME_STAMP_LABEL',
    TIME_STAMP_CONTENT: 'TIME_STAMP_CONTENT',
    PRE_EFFECTIVE_NOTIFICATION: 'PRE_EFFECTIVE_NOTIFICATION',
    TABBED_SERVICES_FACILITIES_TITLE: 'TABBED_SERVICES_FACILITIES_TITLE',
    TABBED_SERVICES_FACILITIES_CONTENT: 'TABBED_SERVICES_FACILITIES_CONTENT',
    HELP_SECTION_TITLE: 'HELP_SECTION_TITLE',
    NETWORK_AFFILIATION_POPOVER_CONTENT: 'NETWORK_AFFILIATION_POPOVER_CONTENT',
    STATE_SPECIFIC_DISCLAIMER: 'STATE_SPECIFIC_DISCLAIMER',
    DENTAL_PROVIDER_NOT_AVAILABLE_CONTENT:
      'DENTAL_PROVIDER_NOT_AVAILABLE_CONTENT',
    PCP_ISPREEFFECTIVE_POPOVER_CONTENT: 'PCP_ISPREEFFECTIVE_POPOVER_CONTENT',
    PATIENT_CENTER_MEDICAL_HOMES_POPOVER_CONTENT:
      'PATIENT_CENTER_MEDICAL_HOMES_POPOVER_CONTENT',
    ESSENTIAL_COMMUNITY_PROVIDER_CONTENT:
      'ESSENTIAL_COMMUNITY_PROVIDER_CONTENT',
    VIEW_ID_CARD_HEADER: 'VIEW_ID_CARD_HEADER',
    VIEW_ID_CARD_CONTENT: 'VIEW_ID_CARD_CONTENT',
    VIEW_ID_CARD_BUTTON: 'VIEW_ID_CARD_BUTTON',
    PCP_NOT_AVAILABLE: 'PCP_NOT_AVAILABLE',
    KELSEY_SEYBOLD_CLINIC_NAME: 'KELSEY_SEYBOLD_CLINIC_NAME',
    SANITAS_CLINIC_NAME: 'SANITAS_CLINIC_NAME',
    KELSEY_SEYBOLD_NAME: 'KELSEY_SEYBOLD_NAME',
    KELSEY_SEYBOLD_PCP_TEXT: 'KELSEY_SEYBOLD_PCP_TEXT',
    EXPANDED_SEARCH_RADIUS_DESCRIPTION: 'EXPANDED_SEARCH_RADIUS_DESCRIPTION',
    UHC_DUAL_COMPLETE_PLAN_DISCLAIMER: 'UHC_DUAL_COMPLETE_PLAN_DISCLAIMER',
    GUEST_GENERAL_DISCLAIMER: 'GUEST_GENERAL_DISCLAIMER',
    UHC_CONNECTED_DISCLAIMER: 'UHC_CONNECTED_DISCLAIMER',
    FIND_CARE_DISCLAIMER: 'FIND_CARE_DISCLAIMER',
    TEXAS_HEALTH_STEPS_PROVIDER: 'TEXAS_HEALTH_STEPS_PROVIDER',
    IN_NETWORK_BANNER_FUTURE_START_DATE: 'IN_NETWORK_BANNER_FUTURE_START_DATE',
    ANTHEM_BLUE_CROSS_DISCLAIMER: 'ANTHEM_BLUE_CROSS_DISCLAIMER',
    ANTHEM_BLUE_CROSS_DISCLAIMER_POPUP: 'ANTHEM_BLUE_CROSS_DISCLAIMER_POPUP',
    NONE_AVAILABLE: 'NONE_AVAILABLE',
    NO_DATA_DISMISSIBLE_BANNER_HEADING: 'NO_DATA_DISMISSIBLE_BANNER_HEADING',
    NO_DATA_DISMISSIBLE_BANNER_DESCRIPTION:
      'NO_DATA_DISMISSIBLE_BANNER_DESCRIPTION',
    FREQUENT_SERVICES_TITLE_DESCRIPTION: 'FREQUENT_SERVICES_TITLE_DESCRIPTION',
    FREQUENT_SERVICES_DESCRIPTION_NO_DATA:
      'FREQUENT_SERVICES_DESCRIPTION_NO_DATA',
    TIER_2_POPOVER_CONTENT: 'TIER_2_POPOVER_CONTENT',
    MARKET_PLACE_HEADING: 'MARKET_PLACE_HEADING',
    MARKET_PLACE_DESCRIPTION: 'MARKET_PLACE_DECRIPTION',
    LIMITED_ACCESS_TO_PROVIDER_BANNER: 'LIMITED_ACCESS_TO_PROVIDER_BANNER',
    BOARD_CERTIFICATIONS_SECTION_DESCRIPTION:
      'BOARD_CERTIFICATIONS_SECTION_DESCRIPTION',
    NETWORK_FACILITY_DIRECTORY_BANNER: 'NETWORK_FACILITY_DIRECTORY_BANNER',
    PROVIDER_DIRECTORY_LABEL: 'PROVIDER_DIRECTORY_LABEL',
    NEW_DESIGN_FEEDBACK_FORM_BANNER: 'NEW_DESIGN_FEEDBACK_FORM_BANNER',
    ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_1:
      'ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_1',
    ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_2:
      'ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_2',
    ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_3:
      'ADVANCED_MEDICAL_HOME_INFO_ICON_BANNER_TIER_3',
    SCHEDULING_WITH_FACILITY_BANNER: 'SCHEDULING_WITH_FACILITY_BANNER',
    PLATINUM_RECOGNITION_POPOVER_CONTENT:
      'PLATINUM_RECOGNITION_POPOVER_CONTENT',
    PREMIUM_CARE_DISCLAIMER: 'PREMIUM_CARE_DISCLAIMER',
    SMART_CHOICE_BREAKDOWN_FAQ_TEXT: 'SMART_CHOICE_BREAKDOWN_FAQ_TEXT',
    DEFAULT_SEARCH_RADIUS_MESSAGE: 'DEFAULT_SEARCH_RADIUS_MESSAGE',
    VIRTUAL_CARE_RESULT_SECTION_TOOLTIP: 'VIRTUAL_CARE_RESULT_SECTION_TOOLTIP',
    DISTANCE_FILTER_MAX_VALIDITY_DAYS: 'DISTANCE_FILTER_MAX_VALIDITY_DAYS',
    UPCOMING_AVAILABILITY_FILTER_MAX_VALIDITY_DAYS:
      'UPCOMING_AVAILABILITY_FILTER_MAX_VALIDITY_DAYS',
    UPCOMING_AVAILABILITY_MESSAGE: 'UPCOMING_AVAILABILITY_MESSAGE',
    SMART_CHOICE_INFO_CONTENT: 'SMART_CHOICE_INFO_CONTENT',
    SMART_CHOICE_QUALITY_BREAKDOWN: {
      QUALITY_BREAKDOWN_TITLE: 'QUALITY_BREAKDOWN_TITLE',
      QUALITY_BREAKDOWN_ALL_CRITERIA_MET_TITLE_AND_DESCRIPTION:
        'QUALITY_BREAKDOWN_ALL_CRITERIA_MET_TITLE_AND_DESCRIPTION',
      QUALITY_BREAKDOWN_DESCRIPTION: 'QUALITY_BREAKDOWN_DESCRIPTION',
      QUALITY_BREAKDOWN_CREDENTIALED_PROVIDER:
        'QUALITY_BREAKDOWN_CREDENTIALED_PROVIDER',
      QUALITY_BREAKDOWN_PREMIUM_CARE_PHYSICIAN:
        'QUALITY_BREAKDOWN_PREMIUM_CARE_PHYSICIAN',
      QUALITY_BREAKDOWN_SERVICE_DATA_AVAILABLE:
        'QUALITY_BREAKDOWN_SERVICE_DATA_AVAILABLE',
      QUALITY_BREAKDOWN_NO_SERVICE_DATA_AVAILABLE:
        'QUALITY_BREAKDOWN_NO_SERVICE_DATA_AVAILABLE',
      QUALITY_BREAKDOWN_MATCH_WHAT_IS_PRIMARY_CARE_PHYSICIAN_Q_AND_A:
        'QUALITY_BREAKDOWN_MATCH_WHAT_IS_PRIMARY_CARE_PHYSICIAN_Q_AND_A',
      QUALITY_BREAKDOWN_NOTMATCH_PRIMARY_CARE_PHYSICIAN_TITLE_AND_DESCRIPTION:
        'QUALITY_BREAKDOWN_NOTMATCH_PRIMARY_CARE_PHYSICIAN_TITLE_AND_DESCRIPTION',
      QUALITY_BREAKDOWN_EXPLORE_UNITED_HEALTHCARE_PREMIUM:
        'QUALITY_BREAKDOWN_EXPLORE_UNITED_HEALTHCARE_PREMIUM',
      QUALITY_BREAKDOWN_SERVICE_DATA_AVAILABLE_TEXT:
        'QUALITY_BREAKDOWN_SERVICE_DATA_AVAILABLE_TEXT',
      QUALITY_BREAKDOWN_NO_SERVICE_DATA_AVAILABLE_TEXT:
        'QUALITY_BREAKDOWN_NO_SERVICE_DATA_AVAILABLE_TEXT',
      PHYSICIAN_DIRECTORY_BH_FACILITY_COPY_CONTENT:
        'PHYSICIAN_DIRECTORY_BH_FACILITY_COPY_CONTENT',
      PHYSICIAN_DIRECTORY_BH_FACILITY_NO_PROVIDER:
        'PHYSICIAN_DIRECTORY_BH_FACILITY_NO_PROVIDER',
    },
    SMART_CHOICE_BENEFITS_BREAKDOWN: {
      EXPLORE_PREMIUM_LINK_EN: 'EXPLORE_PREMIUM_LINK_EN',
      EXPLORE_PREMIUM_LINK_ES: 'EXPLORE_PREMIUM_LINK_ES',
      BENIFITS_BREAKDOWN_TITLE: 'BENIFITS_BREAKDOWN_TITLE',
      BENIFITS_BREAKDOWN_GOOD_MATCH_CONTENT:
        'BENIFITS_BREAKDOWN_GOOD_MATCH_CONTENT',
      BENIFITS_BREAKDOWN_DESCRIPTION: 'BENIFITS_BREAKDOWN_DESCRIPTION',
      BENIFITS_BREAKDOWN_IN_NETWORK: 'BENIFITS_BREAKDOWN_IN_NETWORK',
      BENIFITS_BREAKDOWN_PREFERRED_PROVIDER:
        'BENIFITS_BREAKDOWN_PREFERRED_PROVIDER',
      BENIFITS_BREAKDOWN_PROVIDER_TIER: 'BENIFITS_BREAKDOWN_PROVIDER_TIER',
      BENIFITS_BREAKDOWN_PROVIDER_TIER1_WITH_LOCATION:
        'BENIFITS_BREAKDOWN_PROVIDER_TIER1_WITH_LOCATION',
      BENIFITS_BREAKDOWN_PROVIDER_ISNOT_TIER1_WITH_LOCATION:
        'BENIFITS_BREAKDOWN_PROVIDER_ISNOT_TIER1_WITH_LOCATION',
      BENIFITS_BREAKDOWN_PROVIDER_PARTICIPATES_ACO_NAME:
        'BENIFITS_BREAKDOWN_PROVIDER_PARTICIPATES_ACO_NAME',
      BENIFITS_BREAKDOWN_PROVIDER_PRATICIPATES_ACO_NAME_AND_LOCATION:
        'BENIFITS_BREAKDOWN_PROVIDER_PRATICIPATES_ACO_NAME_AND_LOCATION',
      BENIFITS_BREAKDOWN_DOES_NOT_PARTICIPATES_ELIGIBLE_AT_ACO_NAME:
        'BENIFITS_BREAKDOWN_DOES_NOT_PARTICIPATES_ELIGIBLE_AT_ACO_NAME',
      BENIFITS_BREAKDOWN_PROVIDER_NOT_PARTICIPATES_ACO_NAME_AND_LOCATION:
        'BENIFITS_BREAKDOWN_PROVIDER_NOT_PARTICIPATES_ACO_NAME_AND_LOCATION',
      BENIFITS_BREAKDOWN_BELOW_AVARAGE_COST_FOR_OFFICE_VISIT:
        'BENIFITS_BREAKDOWN_BELOW_AVARAGE_COST_FOR_OFFICE_VISIT',
      BENIFITS_BREAKDOWN_AVERAGE_COST_FOR_OFFICE_VISIT:
        'BENIFITS_BREAKDOWN_AVERAGE_COST_FOR_OFFICE_VISIT',
      BENIFITS_BREAKDOWN_ABOVE_AVERAGE_COST_FOR_OFFICE_VISIT:
        'BENIFITS_BREAKDOWN_ABOVE_AVERAGE_COST_FOR_OFFICE_VISIT',
      BENIFITS_BREAKDOWN_BELOW_AVARAGE_TOTAL_COST_OF_CARE:
        'BENIFITS_BREAKDOWN_BELOW_AVARAGE_TOTAL_COST_OF_CARE',
      BENIFITS_BREAKDOWN_AVERAGE_TOTAL_COST_OF_CARE:
        'BENIFITS_BREAKDOWN_AVERAGE_TOTAL_COST_OF_CARE',
      BENIFITS_BREAKDOWN_ABOVE_AVERAGE_TOTAL_COST_OF_CARE:
        'BENIFITS_BREAKDOWN_ABOVE_AVERAGE_TOTAL_COST_OF_CARE',
    },
    SMART_CHOICE_CONVENIENCE_BREAKDOWN: {
      CONVENIENCE_BREAKDOWN_TITLE: 'CONVENIENCE_BREAKDOWN_TITLE',
      CONVENIENCE_BREAKDOWN_DESCRIPTION: 'CONVENIENCE_BREAKDOWN_DESCRIPTION',
      CONVENIENCE_BREAKDOWN_AVALIABILITY_TITLE:
        'CONVENIENCE_BREAKDOWN_AVALIABILITY_TITLE',
      CONVENIENCE_BREAKDOWN_ACCEPCTING_NEW_PATIENTS:
        'CONVENIENCE_BREAKDOWN_ACCEPCTING_NEW_PATIENTS',
      CONVENIENCE_BREAKDOWN_APPOINTMENTS_ARE_AVAILABILE_WITH_IN:
        'CONVENIENCE_BREAKDOWN_APPOINTMENTS_ARE_AVAILABILE_WITH_IN',
      CONVENIENCE_BREAKDOWN_APPOINTMENTS_ARE_UN_AVAILABILE:
        'CONVENIENCE_BREAKDOWN_APPOINTMENTS_ARE_UN_AVAILABILE',
      CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_AVAILABILE:
        'CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_AVAILABILE',
      CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_UNAVAILABILE:
        'CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_UNAVAILABILE',
      CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_AVAILABILE:
        'CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_AVAILABILE',
      CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_UNAVAILABILE:
        'CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_UNAVAILABILE',
      CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_AVAILABLE_THOUGHT_MYUHC_COM:
        'CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_AVAILABLE_THOUGHT_MYUHC_COM',
      CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_UNAVAILABLE_THOUGHT_MYUHC_COM:
        'CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_UNAVAILABLE_THOUGHT_MYUHC_COM',
      CONVENIENCE_BREAKDOWN_ACCESS_TO_CARE_TITLE:
        'CONVENIENCE_BREAKDOWN_ACCESS_TO_CARE_TITLE',
      CONVENIENCE_BREAKDOWN_WITH_NUMBER_OF_MILES_YOUR_LOCATION:
        'CONVENIENCE_BREAKDOWN_WITH_NUMBER_OF_MILES_YOUR_LOCATION',
      CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_AVAILABLE:
        'CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_AVAILABLE',
      CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_UNAVAILABLE:
        'CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_UNAVAILABLE',
      CONVENIENCE_BREAKDOWN_SCHEDULE_NOW: 'CONVENIENCE_BREAKDOWN_SCHEDULE_NOW',
    },
    SMART_CHOICE_PERSONAL_FIT_BREAKDOWN: {
      PERSONAL_FIT_BREAKDOWN_TITLE: 'PERSONAL_FIT_BREAKDOWN_TITLE',
      PERSONAL_FIT_BREAKDOWN_DESCRIPTION: 'PERSONAL_FIT_BREAKDOWN_DESCRIPTION',
      PERSONAL_FIT_BREAKDOWN_COMPATABILITY_TITLE:
        'PERSONAL_FIT_BREAKDOWN_COMPATABILITY_TITLE',
      PERSONAL_FIT_BREAKDOWN_SPEAKS: 'PERSONAL_FIT_BREAKDOWN_SPEAKS',
      PERSONAL_FIT_BREAKDOWN_DOES_NOT_SPEAKS_LANGUAGE:
        'PERSONAL_FIT_BREAKDOWN_DOES_NOT_SPEAKS_LANGUAGE',
      PERSONAL_FIT_BREAKDOWN_LANGUAGE_UNKNOWN:
        'PERSONAL_FIT_BREAKDOWN_LANGUAGE_UNKNOWN',
      PERSONAL_FIT_BREAKDOWN_PROVIDER_IDENTIFIES_AS:
        'PERSONAL_FIT_BREAKDOWN_PROVIDER_IDENTIFIES_AS',
      PERSONAL_FIT_BREAKDOWN_GENDER_UNKNOWN:
        'PERSONAL_FIT_BREAKDOWN_GENDER_UNKNOWN',
      PERSONAL_FIT_BREAKDOWN_BOARD_CERTIFIED_IN:
        'PERSONAL_FIT_BREAKDOWN_BOARD_CERTIFIED_IN',
      PERSONAL_FIT_BREAKDOWN_NOT_BORD_CERTIFIED:
        'PERSONAL_FIT_BREAKDOWN_NOT_BORD_CERTIFIED',
      PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING_INFO_UNAVAILABLE:
        'PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING_INFO_UNAVAILABLE',
      PERSONAL_FIT_BREAKDOWN_PAITIENT_EXPERIENCE_TITLE:
        'PERSONAL_FIT_BREAKDOWN_PAITIENT_EXPERIENCE_TITLE',
      PERSONAL_FIT_BREAKDOWN_CONSIMER_RATING_STARS_ARE_PROVIDED_BY_HEALTHGRADES:
        'PERSONAL_FIT_BREAKDOWN_CONSIMER_RATING_STARS_ARE_PROVIDED_BY_HEALTHGRADES',
      PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING:
        'PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING',
      PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING_AND_STARS:
        'PERSONAL_FIT_BREAKDOWN_CONSUMER_RATING_AND_STARS',
      PERSONAL_FIT_BREAKDOWN_HEALTHGRADE_DESCRIPTION_AT_END:
        'PERSONAL_FIT_BREAKDOWN_HEALTHGRADE_DESCRIPTION_AT_END',
    },
    SMART_CHOICE_BREAKDOWN: 'SMART_CHOICE_BREAKDOWN',
    SMART_CHOICE_DISCLAIMER: 'SMART_CHOICE_DISCLAIMER',
    SCORE_CALCULATED_LABEL: 'SCORE_CALCULATED_LABEL',
    CRISIS_POPUP_HEADING: 'CRISIS_POPUP_HEADING',
    CRISIS_POPUP_SUBTEXT: 'CRISIS_POPUP_SUBTEXT',
    CRISIS_POPUP_VIEW_CRISIS_RESOURCES_BUTTON:
      'CRISIS_POPUP_VIEW_CRISIS_RESOURCES_BUTTON',
    CLOSE: 'CLOSE',
    STILL_NEED_HELP_TITLE: 'STILL_NEED_HELP_TITLE',
    COMPARE_PROVIDERS_MODAL_POPUP_TITLE_AND_DESCRIPTION:
      'COMPARE_PROVIDERS_MODAL_POPUP_TITLE_AND_DESCRIPTION',
    COMPARE_PROVIDERS: 'COMPARE_PROVIDERS',
    GET_AND_SHARE_INFORMATION_ON_COST: 'GET_AND_SHARE_INFORMATION_ON_COST',
    CALL: 'CALL',
    TEXT: 'TEXT',
    OR: 'OR',
    ERROR_500_MESSAGE: 'ERROR_500_MESSAGE',
    ERROR_500_MESSAGE_2: 'ERROR_500_MESSAGE_2',
    OUT_OF_STATE_BANNER_DESCRIPTION: 'OUT_OF_STATE_BANNER_DESCRIPTION',
    BH_FACILITY_PDF_PRINT_DISCLAIMER: 'BH_FACILITY_PDF_PRINT_DISCLAIMER',
    SMART_CHOICE: {
      SMART_CHOICE: 'SMART_CHOICE',
      SC_ONBOARDING_HEADING_DESC: 'SC_ONBOARDING_HEADING_DESC',
      SC_ONBOARDING_QUALITY_CARE: 'SC_ONBOARDING_QUALITY_CARE',
      SC_ONBOARDING_BENEFITS: 'SC_ONBOARDING_BENEFITS',
      SC_ONBOARDING_CONVENIENCE: 'SC_ONBOARDING_CONVENIENCE',
      SC_ONBOARDING_PERSONAL_FIT: 'SC_ONBOARDING_PERSONAL_FIT',
      SC_ONBOARDING_FAQ_LINK: 'SC_ONBOARDING_FAQ_LINK',
      SC_ONBOARDING_DISCLAIMER_TEXT: 'SC_ONBOARDING_DISCLAIMER_TEXT',
      SC_ONBOARDING_SET_PREFERENCES: 'SC_ONBOARDING_SET_PREFERENCES',
      SMART_CHOICE_INTRO_POP_UP_TITLE: 'SMART_CHOICE_INTRO_POP_UP_TITLE',
      SMART_CHOICE_INTRO_POP_UP_SUBTITLE: 'SMART_CHOICE_INTRO_POP_UP_SUBTITLE',
      SMART_CHOICE_INTRO_POP_UP_DESCRIPTION:
        'SMART_CHOICE_INTRO_POP_UP_DESCRIPTION',
      SMART_CHOICE_INTRO_POP_UP_TEXT: 'SMART_CHOICE_INTRO_POP_UP_TEXT',
      SMART_CHOICE_INTRO_POP_UP_LEARN_ABOUT:
        'SMART_CHOICE_INTRO_POP_UP_LEARN_ABOUT',
      SMART_CHOICE_INTRO_POP_UP_MAY_BE_LATER:
        'SMART_CHOICE_INTRO_POP_UP_MAY_BE_LATER',
      SMART_CHOICE_INTRO_POP_UP_SIMPLE: 'SMART_CHOICE_INTRO_POP_UP_SIMPLE',
      SMART_CHOICE_INTRO_POP_UP_CUSTOMIZED:
        'SMART_CHOICE_INTRO_POP_UP_CUSTOMIZED',
      SMART_CHOICE_INTRO_POP_UP_DATA_DRIVEN:
        'SMART_CHOICE_INTRO_POP_UP_DATA_DRIVEN',
      SC_COACHMARK: 'SC_COACHMARK',
      SMART_CHOICE_AVAILABILITY_FACILITY_DESCRIPTION:
        'SMART_CHOICE_AVAILABILITY_FACILITY_DESCRIPTION',
      SMART_CHOICE_AVAILABILITY_PROVIDER_GROUP:
        'SMART_CHOICE_AVAILABILITY_PROVIDER_GROUP',
      SMART_CHOICE_NOT_AVAILABLE: 'SMART_CHOICE_NOT_AVAILABLE',
      SMART_CHOICE_AVAILABILITY: 'SMART_CHOICE_AVAILABILITY',
      SMART_CHOICE_NOT_AVAILABLE_BEHAVIOURAL_HEALTH:
        'SMART_CHOICE_NOT_AVAILABLE_BEHAVIOURAL_HEALTH',
      SMART_CHOICE_NOT_AVAILABLE_HEALTH_SUPPLIES:
        'SMART_CHOICE_NOT_AVAILABLE_HEALTH_SUPPLIES',
      SMART_CHOICE_NOT_AVAILABLE_FACILITIES:
        'SMART_CHOICE_NOT_AVAILABLE_FACILITIES',
      SMART_CHOICE_NOT_AVAILABLE_VISION: 'SMART_CHOICE_NOT_AVAILABLE_VISION',
      SMART_CHOICE_NOT_AVAILABLE_DENTAL: 'SMART_CHOICE_NOT_AVAILABLE_DENTAL',
      SMART_CHOICE_AVAILABLE_ONLY_FOR_PRIMARY_MEDICAL:
        'SMART_CHOICE_AVAILABLE_ONLY_FOR_PRIMARY_MEDICAL',
      SMART_CHOICE_AVAILABLE_ONLY_FOR_PRIMARY_MEDICAL_STYLED:
        'SMART_CHOICE_AVAILABLE_ONLY_FOR_PRIMARY_MEDICAL_STYLED',
      SMART_CHOICE_AVAILABILITY_DESCRIPTION:
        'SMART_CHOICE_AVAILABILITY_DESCRIPTION',
      SMART_CHOICE_UNAVAILABLE_FOR_THIS_SEARCH:
        'SMART_CHOICE_UNAVAILABLE_FOR_THIS_SEARCH',
      SMART_CHOICE_UNAVAILABLE_FOR_FACILITIES_SEARCH:
        'SMART_CHOICE_UNAVAILABLE_FOR_FACILITIES_SEARCH',
      SMART_CHOICE_UNAVAILABLE_FOR_PROVIDER_GROUP_SEARCH:
        'SMART_CHOICE_UNAVAILABLE_FOR_PROVIDER_GROUP_SEARCH',
      SMART_CHOICE_CONTINUE_TO_PREFERENCES:
        'SMART_CHOICE_CONTINUE_TO_PREFERENCES',
      SMART_CHOICE_UNAVAILABLE_FOR_BH: 'SMART_CHOICE_UNAVAILABLE_FOR_BH',
      SMART_CHOICE_UNAVAILABLE_FOR_HEALTH_SUPPLIES:
        'SMART_CHOICE_UNAVAILABLE_FOR_HEALTH_SUPPLIES',
      SMART_CHOICE_UNAVAILABLE_FOR_FACILITIES:
        'SMART_CHOICE_UNAVAILABLE_FOR_FACILITIES',
      SMART_CHOICE_UNAVAILABLE_FOR_VISION:
        'SMART_CHOICE_UNAVAILABLE_FOR_VISION',
      SMART_CHOICE_UNAVAILABLE_FOR_DENTAL:
        'SMART_CHOICE_UNAVAILABLE_FOR_DENTAL',
      SMART_CHOICE_UNAVAILABLE_FOR_VIRTUAL_CARE:
        'SMART_CHOICE_UNAVAILABLE_FOR_VIRTUAL_CARE',
      PREFERENCES_FORM_HEADING_DESCRIPTION:
        'PREFERENCES_FORM_HEADING_DESCRIPTION',
      PREFERENCES_FORM_PREFERENCES_APPLIED:
        'PREFERENCES_FORM_PREFERENCES_APPLIED',
      PREFERENCES_FORM_CONVENIENCE_TITLE_DESC:
        'PREFERENCES_FORM_CONVENIENCE_TITLE_DESC',
      PREFERENCES_FORM_DISTANCE_WITHIN: 'PREFERENCES_FORM_DISTANCE_WITHIN',
      PREFERENCES_FORM_VIRTUAL_APPOINTMENTS:
        'PREFERENCES_FORM_VIRTUAL_APPOINTMENTS',
      PREFERENCES_FORM_ONLINE_APPOINTMENT_SCHEDULING:
        'PREFERENCES_FORM_ONLINE_APPOINTMENT_SCHEDULING',
      PREFERENCES_FORM_EVENING_APPOINTMENTS:
        'PREFERENCES_FORM_EVENING_APPOINTMENTS',
      PREFERENCES_FORM_WEEKEND_APPOINTMENTS:
        'PREFERENCES_FORM_WEEKEND_APPOINTMENTS',
      PREFERENCES_FORM_PERSONAL_FIT_TITLE_DESC:
        'PREFERENCES_FORM_PERSONAL_FIT_TITLE_DESC',
      PREFERENCES_FORM_LANGUAGES_SPOKEN: 'PREFERENCES_FORM_LANGUAGES_SPOKEN',
      PREFERENCES_FORM_GENDER: 'PREFERENCES_FORM_GENDER',
      PREFERENCES_FORM_BOARD_CERTIFIED: 'PREFERENCES_FORM_BOARD_CERTIFIED',
      PREFERENCES_FORM_SEARCH_PROVIDER: 'PREFERENCES_FORM_SEARCH_PROVIDER',
      PREFERENCES_FORM_NO_PREFERENCES_SET:
        'PREFERENCES_FORM_NO_PREFERENCES_SET',
      PREFERENCES_FORM_CLEAR_ALL: 'PREFERENCES_FORM_CLEAR_ALL',
      PREFERENCES_FORM_WITHIN: 'PREFERENCES_FORM_WITHIN',
      PREFERENCES_FORM_MILE: 'PREFERENCES_FORM_MILE',
      PREFERENCES_FORM_MILES: 'PREFERENCES_FORM_MILES',
      PREFERENCES_FORM_UPDATE_PROVIDER_SCORE:
        'PREFERENCES_FORM_UPDATE_PROVIDER_SCORE',
      UPDATE_SEARCH_RESULTS: 'UPDATE_SEARCH_RESULTS',
    },
    PLATINUM_POPOVER_MESSAGE: 'PLATINUM_POPOVER_MESSAGE',
    PLATINUM_POPOVER_INFO_TEXT: 'PLATINUM_POPOVER_INFO_TEXT',
    PLATINUM_POPOVER_INFO_SUBTEXT: 'PLATINUM_POPOVER_INFO_SUBTEXT',
    PLATINUM_POPOVER_HEADING: 'PLATINUM_POPOVER_HEADING',
    PRIORITY_SCHEDULING_TITLE: 'PRIORITY_SCHEDULING_TITLE',
    PRIORITY_SCHEDULING_POPOVER_INFO_TITLE:
      'PRIORITY_SCHEDULING_POPOVER_INFO_TITLE',
    PRIORITY_SCHEDULING_POPOVER_MESSAGE: 'PRIORITY_SCHEDULING_POPOVER_MESSAGE',
    PRIORITY_SCHEDULING_COACHMARK_MESSAGE:
      'PRIORITY_SCHEDULING_COACHMARK_MESSAGE',
    PRIORITY_SCHEDULING_FILTER_MAX_VALIDITY_DAYS:
      'PRIORITY_SCHEDULING_FILTER_MAX_VALIDITY_DAYS',
    BCC_PROVIDER: 'BCC_PROVIDER',
    PRIORITY_SCHEDULING_TOGGLE_MESSAGE: 'PRIORITY_SCHEDULING_TOGGLE_MESSAGE',
    BENEFITS_SECTION_HEADER_LABEL: 'BENEFITS_SECTION_HEADER_LABEL',
    CARE_TEAM: {
      HEADER_DESCRIPTION: 'HEADER_DESCRIPTION',
      CARE_EMPTY_CARD_DESCRIPTION: 'CARE_EMPTY_CARD_DESCRIPTION',
      CARE_NO_PROVIDER_DESC: 'CARE_NO_PROVIDER_DESC',
      CARE_CHOOSE_PCP_INFO: 'CARE_CHOOSE_PCP_INFO',
      CARE_NEW_PATIENT_DISCLAIMER: 'CARE_NEW_PATIENT_DISCLAIMER',
      CARE_TEAM_BANNER_FOR_SUPPRESSED_PCP:
        'CARE_TEAM_BANNER_FOR_SUPPRESSED_PCP',
      CARE_TEAM_BANNER_FOR_OON_PCP: 'CARE_TEAM_BANNER_FOR_OON_PCP',
      FUTURE_PCP_EFFECTIVE_DATE: 'FUTURE_PCP_EFFECTIVE_DATE',
    },
    MAXIMUM_PROVIDER_LIMIT_BANNER: 'MAXIMUM_PROVIDER_LIMIT_BANNER',
    SMART_CHOICE_QUALITY_PCP_TEXT: 'SMART_CHOICE_QUALITY_PCP_TEXT',
    SMART_CHOICE_QUALITY_PCP_NEGATIVE_TEXT:
      'SMART_CHOICE_QUALITY_PCP_NEGATIVE_TEXT',
    COMPARE: {
      COMPARE_SPECIALTY_NOT_AVAILABLE: 'COMPARE_SPECIALTY_NOT_AVAILABLE',
      COMPARE_PCP_SERVICES_AVAILABLE: 'COMPARE_PCP_SERVICES_AVAILABLE',
      COMPARE_PCP_SERVICES_NOT_AVAILABLE: 'COMPARE_PCP_SERVICES_NOT_AVAILABLE',
      COMPARE_BELOW_AVERAGE_COST: 'COMPARE_BELOW_AVERAGE_COST',
      COMPARE_AVERAGE_COST: 'COMPARE_AVERAGE_COST',
      COMPARE_ABOVE_AVERAGE_COST: 'COMPARE_ABOVE_AVERAGE_COST',
      COMPARE_COST_NOT_AVAILABLE: 'COMPARE_COST_NOT_AVAILABLE',
      COMPARE_NOT_AVAILABLE_TEXT: 'COMPARE_NOT_AVAILABLE_TEXT',
      COMPARE_MALE: 'COMPARE_MALE',
      COMPARE_FEMALE: 'COMPARE_FEMALE',
      COMPARE_BACK_TO_RESULTS_HEADING: 'COMPARE_BACK_TO_RESULTS_HEADING',
      COMPARE_BACK_TO_RESULTS_BUTTON: 'COMPARE_BACK_TO_RESULTS_BUTTON',
      COMPARE_NO_COMPARISON: 'COMPARE_NO_COMPARISON',
      COMPARE_PRIMARY_CARE_PROVIDER: 'COMPARE_PRIMARY_CARE_PROVIDER',
      COMPARE_EDUCATION_INFO_NOT_AVAILABLE:
        'COMPARE_EDUCATION_INFO_NOT_AVAILABLE',
      COMPARE_ETHINICITY_INFO_NOT_AVAILABLE:
        'COMPARE_ETHINICITY_INFO_NOT_AVAILABLE',
      COMPARE_TIER_2_PROVIDER: 'COMPARE_TIER_2_PROVIDER',
      COMPARE_NOT_TIERED_PROVIDER: 'COMPARE_NOT_TIERED_PROVIDER',
      COMPARE_NOT_PREFERRED_PROVIDER: 'COMPARE_NOT_PREFERRED_PROVIDER',
      COMPARE_NOT_ACO_PROVIDER: 'COMPARE_NOT_ACO_PROVIDER',
      COMPARE_IN_NETWORK: 'COMPARE_IN_NETWORK',
      COMPARE_OUT_OF_NETWORK: 'COMPARE_OUT_OF_NETWORK',
      COMPARE_NOT_BOARD_CERTIFIED: 'COMPARE_NOT_BOARD_CERTIFIED',
      COMPARE_NOT_ACCEPTING_NEW_PATIENTS: 'COMPARE_NOT_ACCEPTING_NEW_PATIENTS',
      COMPARE_OFFERS_VIRTUAL_CARE: 'COMPARE_OFFERS_VIRTUAL_CARE',
      COMPARE_NO_VIRTUAL_CARE: 'COMPARE_NO_VIRTUAL_CARE',
      COMPARE_EDIT_COMPARISON: 'COMPARE_EDIT_COMPARISON',
      COMPARE_ACO_PROVIDER_TEXT: 'COMPARE_ACO_PROVIDER_TEXT',
      COMPARE_NOT_A_CREDENTIALED_PROVIDER:
        'COMPARE_NOT_A_CREDENTIALED_PROVIDER',
      COMPARE_EDIT_SPECIALTY: 'COMPARE_EDIT_SPECIALTY',
      COMPARE_EDIT_PCP_SERVICE: 'COMPARE_EDIT_PCP_SERVICE',
      COMPARE_EDIT_PREMIUM_CARE: 'COMPARE_EDIT_PREMIUM_CARE',
      COMPARE_EDIT_CREDENTIALED: 'COMPARE_EDIT_CREDENTIALED',
      COMPARE_EDIT_SERVICE_DATA: 'COMPARE_EDIT_SERVICE_DATA',
      COMPARE_EDIT_NETWORK_STATUS: 'COMPARE_EDIT_NETWORK_STATUS',
      COMPARE_EDIT_TIER: 'COMPARE_EDIT_TIER',
      COMPARE_EDIT_GREEN_DIAMOND: 'COMPARE_EDIT_GREEN_DIAMOND',
      COMPARE_EDIT_AFFILIATION: 'COMPARE_EDIT_AFFILIATION',
      COMPARE_EDIT_COST_INDICATOR: 'COMPARE_EDIT_COST_INDICATOR',
      COMPARE_EDIT_ACCEPTING_NEW_PATIENTS:
        'COMPARE_EDIT_ACCEPTING_NEW_PATIENTS',
      COMPARE_EDIT_ETHNICITY: 'COMPARE_EDIT_ETHNICITY',
      COMPARE_EDIT_HOURS_OF_OPERATION: 'COMPARE_EDIT_HOURS_OF_OPERATION',
      COMPARE_EDIT_EVENING_AVAILABILITY: 'COMPARE_EDIT_EVENING_AVAILABILITY',
      COMPARE_EDIT_WEEKEND_AVAILABILITY: 'COMPARE_EDIT_WEEKEND_AVAILABILITY',
      COMPARE_EDIT_ONLINE_AVAILABILITY: 'COMPARE_EDIT_ONLINE_AVAILABILITY',
      COMPARE_EDIT_VIRTUAL_APPOINTMENT: 'COMPARE_EDIT_VIRTUAL_APPOINTMENT',
      COMPARE_EDIT_DISTANCE: 'COMPARE_EDIT_DISTANCE',
      COMPARE_EDIT_LANGUAGE_SPOKEN: 'COMPARE_EDIT_LANGUAGE_SPOKEN',
      COMPARE_EDIT_GENDER: 'COMPARE_EDIT_GENDER',
      COMPARE_EDIT_BOARD_CERTIFIED: 'COMPARE_EDIT_BOARD_CERTIFIED',
      COMPARE_EDIT_RATINGS: 'COMPARE_EDIT_RATINGS',
      COMPARE_ADD_TO_COMPARE_TEXT: 'COMPARE_ADD_TO_COMPARE_TEXT',
      COMPARE_LINK_COMPARE_NOW: 'COMPARE_LINK_COMPARE_NOW',
      COMPARE_SWAP_PROVIDERS_HEADING: 'COMPARE_SWAP_PROVIDERS_HEADING',
      COMPARE_SWAP_PROVIDER_BUTTON: 'COMPARE_SWAP_PROVIDER_BUTTON',
      COMPARE_PICK_A_PROVIDER: 'COMPARE_PICK_A_PROVIDER',
      COMPARE_BELOW_AVERAGE_COST_CARE: 'COMPARE_BELOW_AVERAGE_COST_CARE',
      COMPARE_AVERAGE_COST_CARE: 'COMPARE_AVERAGE_COST_CARE',
      COMPARE_ABOVE_AVERAGE_COST_CARE: 'COMPARE_ABOVE_AVERAGE_COST_CARE',
      COMPARE_COST_CARE_NOT_AVAILABLE: 'COMPARE_COST_CARE_NOT_AVAILABLE',
      COMPARE_EDIT_TOTAL_COST_OF_CARE: 'COMPARE_EDIT_TOTAL_COST_OF_CARE',
      COMPARE_QUALITY_PCP_TEXT: 'COMPARE_QUALITY_PCP_TEXT',
      COMPARE_QUALITY_PCP_SUBTEXT: 'COMPARE_QUALITY_PCP_SUBTEXT',
      COMPARE_QUALITY_NO_PCP_TEXT: 'COMPARE_QUALITY_NO_PCP_TEXT',
      COMPARE_QUALITY_NO_PCP_SUBTEXT: 'COMPARE_QUALITY_NO_PCP_SUBTEXT',
      COMPARE_EDIT_RACE: 'COMPARE_EDIT_RACE',
    },
    TYPEAHEAD_SEARCH_HEADER_IFP_EARLYPAY:
      'TYPEAHEAD_SEARCH_HEADER_IFP_EARLYPAY',
    ABOUT_AFTER_HOURS_TITLE: 'ABOUT_AFTER_HOURS_TITLE',
    ABOUT_AFTER_HOURS_CONTENT: 'ABOUT_AFTER_HOURS_CONTENT',
    ICARE_TYPE_AHEAD_SEARCH_CONTENT: 'ICARE_TYPE_AHEAD_SEARCH_CONTENT',
    LEARN_MORE_HYPERLINK_DRAWER_DESCRIPTION:
      'LEARN_MORE_HYPERLINK_DRAWER_DESCRIPTION',
    LEARN_MORE_HYPERLINK_DRAWER_TITLE: 'LEARN_MORE_HYPERLINK_DRAWER_TITLE',
    PRIORITY_SCHEDULING_BCC_PROVIDER: 'PRIORITY_SCHEDULING_BCC_PROVIDER',
    PRIORITY_SCHEDULING_BCC_PROVIDER_UNDO:
      'PRIORITY_SCHEDULING_BCC_PROVIDER_UNDO',
    PRIORITY_SCHEDULING_ALL_PROVIDERS: 'PRIORITY_SCHEDULING_ALL_PROVIDERS',
    PROVIDER_NOT_FOUND: 'PROVIDER_NOT_FOUND',
  },
  QUICK_CARE: {
    VIRTUAL_CARE: 'VIRTUAL_CARE',
    VIRTUAL_CARE_RAILROAD: 'VIRTUAL_CARE_RAILROAD',
    VIRTUAL_CARE_KELSEY_SEYBOLD: 'VIRTUAL_CARE_KELSEY_SEYBOLD',
  },
  LANDING_INFO: {
    TIME_STAMP_CONTENT: 'TIME_STAMP_CONTENT',
  },
  FACILITY_LOCATIONS: {
    SPECIALTIES_OFFERED_BY_FACILITY: 'SPECIALTIES_OFFERED_BY_FACILITY',
  },
  CONFIG: {
    MAP_VIEW_PAGE_SIZE: 'MAP_VIEW_PAGE_SIZE',
    MAP_PINS_PAGE_SIZE: 'MAP_PINS_PAGE_SIZE',
    SMART_CHOICE_MAP_PINS_PAGE_SIZE: 'SMART_CHOICE_MAP_PINS_PAGE_SIZE',
    SMART_CHOICE_PES_LANG_CODES: 'SMART_CHOICE_PES_LANG_CODES',
    PEDIATRIC_SPECIALTY_CODES: 'PEDIATRIC_SPECIALTY_CODES',
    SUPPRESSED_POPULATION_FOR_VIRTUAL_CARE:
      'SUPPRESSED_POPULATION_FOR_VIRTUAL_CARE',
  },
  GUEST_PLAN_SELECTION: {
    TYPE_OF_CARE: 'TYPE_OF_CARE',
    CHOOSE_TYPE_OF_CARE: 'CHOOSE_TYPE_OF_CARE',
    CHOOSE_A_YEAR_HEADING: 'CHOOSE_A_YEAR_HEADING',
    TYPE_OF_MEDICAL_COVERAGE: 'TYPE_OF_MEDICAL_COVERAGE',
    YEAR_SELECTION_CURRENT_YEAR: 'YEAR_SELECTION_CURRENT_YEAR',
    YEAR_SELECTION_FUTURE_YEAR: 'YEAR_SELECTION_FUTURE_YEAR',
    YEAR_SELECTION_DESCRIPTION: 'YEAR_SELECTION_DESCRIPTION',
    YEAR_SELECTION_BUTTON_TEXT: 'YEAR_SELECTION_BUTTON_TEXT',
    TYPE_OF_CARE_HEADING: 'TYPE_OF_CARE_HEADING',
    SIGN_IN_MESSAGE: 'SIGN_IN_MESSAGE',
    SIGN_IN: 'SIGN_IN',
    EXPLORE: 'EXPLORE',
    CHOOSE_MEDICAL_COVERAGE_TYPE: 'CHOOSE_MEDICAL_COVERAGE_TYPE',
    TYPE_OF_MEDICAL_COVERAGE_HEADING: 'TYPE_OF_MEDICAL_COVERAGE_HEADING',
    EXPLORE_COVERAGE: 'EXPLORE_COVERAGE',
    PLAN_SELECTION: 'PLAN_SELECTION',
    YEAR_SELECTION: 'YEAR_SELECTION',
    CHOOSE_A_PLAN: 'CHOOSE_A_PLAN',
    CHOOSE_A_YEAR: 'CHOOSE_A_YEAR',
    CHOOSE_A_LOCATION: 'CHOOSE_A_LOCATION',
    SELECT_LOCATION_HEADING: 'SELECT_LOCATION_HEADING',
    SELECT_LOCATION_SINGLE_PLAN_HEADING: 'SELECT_LOCATION_SINGLE_PLAN_HEADING',
    SELECT_LOCATION_MESSAGE: 'SELECT_LOCATION_MESSAGE',
    CHOOSE_MEDICAID_PLAN: 'CHOOSE_MEDICAID_PLAN',
    NULL_LOCATION_MESSAGE: 'NULL_LOCATION_MESSAGE',
    CHOOSE_MEDICARE_PLAN: 'CHOOSE_MEDICARE_PLAN',
    NO_PLANS_IN_SELECTED_AREA: 'NO_PLANS_IN_SELECTED_AREA',
    PLAN_NAME: 'PLAN_NAME',
    ENTER_A_PLAN_NAME: 'ENTER_A_PLAN_NAME',
    PLAN_TYPE: 'PLAN_TYPE',
    CLEAR: 'CLEAR',
    LEVEL_FUNDED_HEALTH_PLANS: 'LEVEL_FUNDED_HEALTH_PLANS',
    PLANS_A_Z: 'PLANS_A_Z',
    PLANS_Z_A: 'PLANS_Z_A',
    LOCATION_MODAL_HEADING: 'LOCATION_MODAL_HEADING',
    LOCATION_MODAL_SUBHEADING: 'LOCATION_MODAL_SUBHEADING',
    LOCATION_MODAL_SIGN_IN: 'LOCATION_MODAL_SIGN_IN',
    LOCATION_MODAL_SEARCH: 'LOCATION_MODAL_SEARCH',
    LOCATION_SEARCH_INSTRUCTIONS: 'LOCATION_SEARCH_INSTRUCTIONS',
    LOCATION_SEARCH_PLACEHOLDER: 'LOCATION_SEARCH_PLACEHOLDER',
    NO_MATCHING_PLANS: 'NO_MATCHING_PLANS',
    DUAL_COMPLETE_PLAN_MESSAGING: 'DUAL_COMPLETE_PLAN_MESSAGING',
    GUEST_HEADER_SIGN_IN: 'GUEST_HEADER_SIGN_IN',
    GUEST_START_MODAL_TITLE: 'GUEST_START_MODAL_TITLE',
    GUEST_START_MODAL_DESCRIPTION: 'GUEST_START_MODAL_DESCRIPTION',
    GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_TITLE:
      'GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_TITLE',
    GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_DESC:
      'GUEST_SIGN_IN_TO_SCHEDULE_ONLINE_DESC',
    LEARN_MORE_BUTTON_TEXT: 'LEARN_MORE_BUTTON_TEXT',
    LOB_PICKER_FIRST_TIME_USER_BANNER_TEXT:
      'LOB_PICKER_FIRST_TIME_USER_BANNER_TEXT',
    LOB_PICKER_DRAWER_CONTENT: 'LOB_PICKER_DRAWER_CONTENT',
    LOB_PICKER_DRAWER_HEADER: 'LOB_PICKER_DRAWER_HEADER',
    TYPE_OF_CARE_PICKER_FIRST_TIME_USER_BANNER_TEXT:
      'TYPE_OF_CARE_PICKER_FIRST_TIME_USER_BANNER_TEXT',
    TYPE_OF_CARE_PICKER_DRAWER_CONTENT: 'TYPE_OF_CARE_PICKER_DRAWER_CONTENT',
    TYPE_OF_CARE_PICKER_DRAWER_HEADER: 'TYPE_OF_CARE_PICKER_DRAWER_HEADER',
    PLAN_SELECTION_FIRST_TIME_USER_BANNER_TEXT:
      'PLAN_SELECTION_FIRST_TIME_USER_BANNER_TEXT',
    PLAN_SELECTION_COACHMARK_TITLE: 'PLAN_SELECTION_COACHMARK_TITLE',
    PLAN_SELECTION_COACHMARK_CONTENT: 'PLAN_SELECTION_COACHMARK_CONTENT',
    GUEST_TIMEOUT_WARNING_MODAL_BODY: 'GUEST_TIMEOUT_WARNING_MODAL_BODY',
    GUEST_TIMEOUT_MODAL_BODY: 'GUEST_TIMEOUT_MODAL_BODY',
    SESSION_TIMEOUT_MILLIS: 'SESSION_TIMEOUT_MILLIS'
  },
};
